(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };
},{"core-js/library/fn/array/from":10}],2:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };
},{"core-js/library/fn/get-iterator":11}],3:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };
},{"core-js/library/fn/json/stringify":12}],4:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/object/values"), __esModule: true };
},{"core-js/library/fn/object/values":13}],5:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };
},{"core-js/library/fn/promise":14}],6:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };
},{"core-js/library/fn/symbol":15}],7:[function(require,module,exports){
module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };
},{"core-js/library/fn/symbol/iterator":16}],8:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _from = require("../core-js/array/from");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};
},{"../core-js/array/from":1}],9:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _iterator = require("../core-js/symbol/iterator");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require("../core-js/symbol");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
},{"../core-js/symbol":6,"../core-js/symbol/iterator":7}],10:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;

},{"../../modules/_core":24,"../../modules/es6.array.from":92,"../../modules/es6.string.iterator":96}],11:[function(require,module,exports){
require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');

},{"../modules/core.get-iterator":91,"../modules/es6.string.iterator":96,"../modules/web.dom.iterable":103}],12:[function(require,module,exports){
var core = require('../../modules/_core');
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

},{"../../modules/_core":24}],13:[function(require,module,exports){
require('../../modules/es7.object.values');
module.exports = require('../../modules/_core').Object.values;

},{"../../modules/_core":24,"../../modules/es7.object.values":98}],14:[function(require,module,exports){
require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.promise');
require('../modules/es7.promise.finally');
require('../modules/es7.promise.try');
module.exports = require('../modules/_core').Promise;

},{"../modules/_core":24,"../modules/es6.object.to-string":94,"../modules/es6.promise":95,"../modules/es6.string.iterator":96,"../modules/es7.promise.finally":99,"../modules/es7.promise.try":100,"../modules/web.dom.iterable":103}],15:[function(require,module,exports){
require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
require('../../modules/es7.symbol.async-iterator');
require('../../modules/es7.symbol.observable');
module.exports = require('../../modules/_core').Symbol;

},{"../../modules/_core":24,"../../modules/es6.object.to-string":94,"../../modules/es6.symbol":97,"../../modules/es7.symbol.async-iterator":101,"../../modules/es7.symbol.observable":102}],16:[function(require,module,exports){
require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');

},{"../../modules/_wks-ext":88,"../../modules/es6.string.iterator":96,"../../modules/web.dom.iterable":103}],17:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],18:[function(require,module,exports){
module.exports = function () { /* empty */ };

},{}],19:[function(require,module,exports){
module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

},{}],20:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":44}],21:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":79,"./_to-iobject":81,"./_to-length":82}],22:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof');
var TAG = require('./_wks')('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

},{"./_cof":23,"./_wks":89}],23:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],24:[function(require,module,exports){
var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],25:[function(require,module,exports){
'use strict';
var $defineProperty = require('./_object-dp');
var createDesc = require('./_property-desc');

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

},{"./_object-dp":56,"./_property-desc":69}],26:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":17}],27:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],28:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":33}],29:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":35,"./_is-object":44}],30:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],31:[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

},{"./_object-gops":61,"./_object-keys":64,"./_object-pie":65}],32:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var ctx = require('./_ctx');
var hide = require('./_hide');
var has = require('./_has');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":24,"./_ctx":26,"./_global":35,"./_has":36,"./_hide":37}],33:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],34:[function(require,module,exports){
var ctx = require('./_ctx');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var anObject = require('./_an-object');
var toLength = require('./_to-length');
var getIterFn = require('./core.get-iterator-method');
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;

},{"./_an-object":20,"./_ctx":26,"./_is-array-iter":42,"./_iter-call":45,"./_to-length":82,"./core.get-iterator-method":90}],35:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],36:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],37:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":28,"./_object-dp":56,"./_property-desc":69}],38:[function(require,module,exports){
var document = require('./_global').document;
module.exports = document && document.documentElement;

},{"./_global":35}],39:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":28,"./_dom-create":29,"./_fails":33}],40:[function(require,module,exports){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

},{}],41:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":23}],42:[function(require,module,exports){
// check on default Array iterator
var Iterators = require('./_iterators');
var ITERATOR = require('./_wks')('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

},{"./_iterators":50,"./_wks":89}],43:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

},{"./_cof":23}],44:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],45:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

},{"./_an-object":20}],46:[function(require,module,exports){
'use strict';
var create = require('./_object-create');
var descriptor = require('./_property-desc');
var setToStringTag = require('./_set-to-string-tag');
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

},{"./_hide":37,"./_object-create":55,"./_property-desc":69,"./_set-to-string-tag":73,"./_wks":89}],47:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var $export = require('./_export');
var redefine = require('./_redefine');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var $iterCreate = require('./_iter-create');
var setToStringTag = require('./_set-to-string-tag');
var getPrototypeOf = require('./_object-gpo');
var ITERATOR = require('./_wks')('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

},{"./_export":32,"./_hide":37,"./_iter-create":46,"./_iterators":50,"./_library":51,"./_object-gpo":62,"./_redefine":71,"./_set-to-string-tag":73,"./_wks":89}],48:[function(require,module,exports){
var ITERATOR = require('./_wks')('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

},{"./_wks":89}],49:[function(require,module,exports){
module.exports = function (done, value) {
  return { value: value, done: !!done };
};

},{}],50:[function(require,module,exports){
module.exports = {};

},{}],51:[function(require,module,exports){
module.exports = true;

},{}],52:[function(require,module,exports){
var META = require('./_uid')('meta');
var isObject = require('./_is-object');
var has = require('./_has');
var setDesc = require('./_object-dp').f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !require('./_fails')(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

},{"./_fails":33,"./_has":36,"./_is-object":44,"./_object-dp":56,"./_uid":85}],53:[function(require,module,exports){
var global = require('./_global');
var macrotask = require('./_task').set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = require('./_cof')(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

},{"./_cof":23,"./_global":35,"./_task":78}],54:[function(require,module,exports){
'use strict';
// 25.4.1.5 NewPromiseCapability(C)
var aFunction = require('./_a-function');

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

},{"./_a-function":17}],55:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require('./_an-object');
var dPs = require('./_object-dps');
var enumBugKeys = require('./_enum-bug-keys');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":20,"./_dom-create":29,"./_enum-bug-keys":30,"./_html":38,"./_object-dps":57,"./_shared-key":74}],56:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":20,"./_descriptors":28,"./_ie8-dom-define":39,"./_to-primitive":84}],57:[function(require,module,exports){
var dP = require('./_object-dp');
var anObject = require('./_an-object');
var getKeys = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

},{"./_an-object":20,"./_descriptors":28,"./_object-dp":56,"./_object-keys":64}],58:[function(require,module,exports){
var pIE = require('./_object-pie');
var createDesc = require('./_property-desc');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var has = require('./_has');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

},{"./_descriptors":28,"./_has":36,"./_ie8-dom-define":39,"./_object-pie":65,"./_property-desc":69,"./_to-iobject":81,"./_to-primitive":84}],59:[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject');
var gOPN = require('./_object-gopn').f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":60,"./_to-iobject":81}],60:[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = require('./_object-keys-internal');
var hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

},{"./_enum-bug-keys":30,"./_object-keys-internal":63}],61:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],62:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require('./_has');
var toObject = require('./_to-object');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

},{"./_has":36,"./_shared-key":74,"./_to-object":83}],63:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":21,"./_has":36,"./_shared-key":74,"./_to-iobject":81}],64:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":30,"./_object-keys-internal":63}],65:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],66:[function(require,module,exports){
var DESCRIPTORS = require('./_descriptors');
var getKeys = require('./_object-keys');
var toIObject = require('./_to-iobject');
var isEnum = require('./_object-pie').f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

},{"./_descriptors":28,"./_object-keys":64,"./_object-pie":65,"./_to-iobject":81}],67:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

},{}],68:[function(require,module,exports){
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var newPromiseCapability = require('./_new-promise-capability');

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

},{"./_an-object":20,"./_is-object":44,"./_new-promise-capability":54}],69:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],70:[function(require,module,exports){
var hide = require('./_hide');
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

},{"./_hide":37}],71:[function(require,module,exports){
module.exports = require('./_hide');

},{"./_hide":37}],72:[function(require,module,exports){
'use strict';
var global = require('./_global');
var core = require('./_core');
var dP = require('./_object-dp');
var DESCRIPTORS = require('./_descriptors');
var SPECIES = require('./_wks')('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};

},{"./_core":24,"./_descriptors":28,"./_global":35,"./_object-dp":56,"./_wks":89}],73:[function(require,module,exports){
var def = require('./_object-dp').f;
var has = require('./_has');
var TAG = require('./_wks')('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

},{"./_has":36,"./_object-dp":56,"./_wks":89}],74:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":75,"./_uid":85}],75:[function(require,module,exports){
var core = require('./_core');
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: require('./_library') ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

},{"./_core":24,"./_global":35,"./_library":51}],76:[function(require,module,exports){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = require('./_an-object');
var aFunction = require('./_a-function');
var SPECIES = require('./_wks')('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

},{"./_a-function":17,"./_an-object":20,"./_wks":89}],77:[function(require,module,exports){
var toInteger = require('./_to-integer');
var defined = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

},{"./_defined":27,"./_to-integer":80}],78:[function(require,module,exports){
var ctx = require('./_ctx');
var invoke = require('./_invoke');
var html = require('./_html');
var cel = require('./_dom-create');
var global = require('./_global');
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (require('./_cof')(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

},{"./_cof":23,"./_ctx":26,"./_dom-create":29,"./_global":35,"./_html":38,"./_invoke":40}],79:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":80}],80:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],81:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":27,"./_iobject":41}],82:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":80}],83:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":27}],84:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":44}],85:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],86:[function(require,module,exports){
var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';

},{"./_global":35}],87:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var LIBRARY = require('./_library');
var wksExt = require('./_wks-ext');
var defineProperty = require('./_object-dp').f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

},{"./_core":24,"./_global":35,"./_library":51,"./_object-dp":56,"./_wks-ext":88}],88:[function(require,module,exports){
exports.f = require('./_wks');

},{"./_wks":89}],89:[function(require,module,exports){
var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

},{"./_global":35,"./_shared":75,"./_uid":85}],90:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

},{"./_classof":22,"./_core":24,"./_iterators":50,"./_wks":89}],91:[function(require,module,exports){
var anObject = require('./_an-object');
var get = require('./core.get-iterator-method');
module.exports = require('./_core').getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

},{"./_an-object":20,"./_core":24,"./core.get-iterator-method":90}],92:[function(require,module,exports){
'use strict';
var ctx = require('./_ctx');
var $export = require('./_export');
var toObject = require('./_to-object');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var toLength = require('./_to-length');
var createProperty = require('./_create-property');
var getIterFn = require('./core.get-iterator-method');

$export($export.S + $export.F * !require('./_iter-detect')(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

},{"./_create-property":25,"./_ctx":26,"./_export":32,"./_is-array-iter":42,"./_iter-call":45,"./_iter-detect":48,"./_to-length":82,"./_to-object":83,"./core.get-iterator-method":90}],93:[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables');
var step = require('./_iter-step');
var Iterators = require('./_iterators');
var toIObject = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

},{"./_add-to-unscopables":18,"./_iter-define":47,"./_iter-step":49,"./_iterators":50,"./_to-iobject":81}],94:[function(require,module,exports){

},{}],95:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var global = require('./_global');
var ctx = require('./_ctx');
var classof = require('./_classof');
var $export = require('./_export');
var isObject = require('./_is-object');
var aFunction = require('./_a-function');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var speciesConstructor = require('./_species-constructor');
var task = require('./_task').set;
var microtask = require('./_microtask')();
var newPromiseCapabilityModule = require('./_new-promise-capability');
var perform = require('./_perform');
var userAgent = require('./_user-agent');
var promiseResolve = require('./_promise-resolve');
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[require('./_wks')('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = require('./_redefine-all')($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
require('./_set-to-string-tag')($Promise, PROMISE);
require('./_set-species')(PROMISE);
Wrapper = require('./_core')[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && require('./_iter-detect')(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

},{"./_a-function":17,"./_an-instance":19,"./_classof":22,"./_core":24,"./_ctx":26,"./_export":32,"./_for-of":34,"./_global":35,"./_is-object":44,"./_iter-detect":48,"./_library":51,"./_microtask":53,"./_new-promise-capability":54,"./_perform":67,"./_promise-resolve":68,"./_redefine-all":70,"./_set-species":72,"./_set-to-string-tag":73,"./_species-constructor":76,"./_task":78,"./_user-agent":86,"./_wks":89}],96:[function(require,module,exports){
'use strict';
var $at = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

},{"./_iter-define":47,"./_string-at":77}],97:[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global = require('./_global');
var has = require('./_has');
var DESCRIPTORS = require('./_descriptors');
var $export = require('./_export');
var redefine = require('./_redefine');
var META = require('./_meta').KEY;
var $fails = require('./_fails');
var shared = require('./_shared');
var setToStringTag = require('./_set-to-string-tag');
var uid = require('./_uid');
var wks = require('./_wks');
var wksExt = require('./_wks-ext');
var wksDefine = require('./_wks-define');
var enumKeys = require('./_enum-keys');
var isArray = require('./_is-array');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var toObject = require('./_to-object');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var createDesc = require('./_property-desc');
var _create = require('./_object-create');
var gOPNExt = require('./_object-gopn-ext');
var $GOPD = require('./_object-gopd');
var $GOPS = require('./_object-gops');
var $DP = require('./_object-dp');
var $keys = require('./_object-keys');
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !require('./_library')) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

},{"./_an-object":20,"./_descriptors":28,"./_enum-keys":31,"./_export":32,"./_fails":33,"./_global":35,"./_has":36,"./_hide":37,"./_is-array":43,"./_is-object":44,"./_library":51,"./_meta":52,"./_object-create":55,"./_object-dp":56,"./_object-gopd":58,"./_object-gopn":60,"./_object-gopn-ext":59,"./_object-gops":61,"./_object-keys":64,"./_object-pie":65,"./_property-desc":69,"./_redefine":71,"./_set-to-string-tag":73,"./_shared":75,"./_to-iobject":81,"./_to-object":83,"./_to-primitive":84,"./_uid":85,"./_wks":89,"./_wks-define":87,"./_wks-ext":88}],98:[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = require('./_export');
var $values = require('./_object-to-array')(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

},{"./_export":32,"./_object-to-array":66}],99:[function(require,module,exports){
// https://github.com/tc39/proposal-promise-finally
'use strict';
var $export = require('./_export');
var core = require('./_core');
var global = require('./_global');
var speciesConstructor = require('./_species-constructor');
var promiseResolve = require('./_promise-resolve');

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });

},{"./_core":24,"./_export":32,"./_global":35,"./_promise-resolve":68,"./_species-constructor":76}],100:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-promise-try
var $export = require('./_export');
var newPromiseCapability = require('./_new-promise-capability');
var perform = require('./_perform');

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });

},{"./_export":32,"./_new-promise-capability":54,"./_perform":67}],101:[function(require,module,exports){
require('./_wks-define')('asyncIterator');

},{"./_wks-define":87}],102:[function(require,module,exports){
require('./_wks-define')('observable');

},{"./_wks-define":87}],103:[function(require,module,exports){
require('./es6.array.iterator');
var global = require('./_global');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var TO_STRING_TAG = require('./_wks')('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

},{"./_global":35,"./_hide":37,"./_iterators":50,"./_wks":89,"./es6.array.iterator":93}],104:[function(require,module,exports){
'use strict';

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = window.jQuery;
var Drupal = window.Drupal;

$(function () {

  var validationFlag = false;
  var TnCvalidationFlag = false;
  $('#campaignClose').click(function () {
    // Close
    $('#campaignPopup').hide();
    localStorage.setItem('campaign_popup_duration', Date.now());
  });

  $("#emailField").keyup(function () {
    // Validations
    var enteredEmail = $(this).val();
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (regex.test(enteredEmail)) {
      if (TnCvalidationFlag) {
        $('#campaign_button').removeClass("disabled");
      }
      validationFlag = true;
    } else {
      if (!$("#campaign_button").hasClass("disabled")) {
        $('#campaign_button').addClass("disabled");
      }
      validationFlag = false;
    }
  });
  $('#TnCfield').click(function () {
    if ($(this).is(":checked")) {
      if (validationFlag) {
        $('#campaign_button').removeClass("disabled");
      }
      TnCvalidationFlag = true;
    } else {
      if (!$("#campaign_button").hasClass("disabled")) {
        $('#campaign_button').addClass("disabled");
      }
      TnCvalidationFlag = false;
    }
  });

  $('#campaign_button').click(function () {
    // Submit API
    if (!$("#campaign_button").hasClass("disabled")) {
      var email = $("#emailField").val();
      var data = {
        "EmailAddress": email,
        "Resubscribe": true,
        "ConsentToTrack": "Yes"
      };
      // asana task: 1209390008791244/task/1210046884387537
      var list_id = "7c73b8a4c1c9e524fb2cbc6add5922b2";
      var currentURL = window.location.pathname;
      if (currentURL) {
        var accepted_links = ['/lapsen-allergia', '/lapset-ja-allergia', '/lapsen-allergia/lapsen-siitepolyallergia', '/lapsen-allergia/lapsen-astma-ja-allergia', '/lapsen-allergia/lapsen-allergian-hoito', '/lapsen-allergia/lasten-allergiatestit'];
        var result = accepted_links.includes(currentURL);
        if (result) {
          var list_id = "6ab9b5f11ba8b53dbc90e3409942eb0a";
        }
      }
      var bodyData = {
        "method": "post",
        "path": "/api/v3.3/subscribers/" + list_id + ".json",
        "shop": "siitepolytieto",
        "list_id": list_id,
        "data": data
      };
      fetch('https://datahub-v2.klarify.me/api/campaign-monitor/common', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: (0, _stringify2.default)(bodyData)
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.status == 201) {
          var messageToShow = 'Kiitos tilauksestasi!';
        } else {
          var messageToShow = 'Subscription failed!';
        }
        $('#emailField').hide();
        $('#heading').hide();
        $('#bodyText').hide();
        $('#TnCwrapper').hide();
        $('#campaign_button').hide();
        $('#textMarkup').html(messageToShow);
        $('#textMarkup').show();
      }).catch(function (error) {
        console.error('Error:', error);
        $('#emailField').hide();
        $('#heading').hide();
        $('#bodyText').hide();
        $('#TnCwrapper').hide();
        $('#campaign_button').hide();
        $('#textMarkup').html('An error occurred. Please try again later.');
        $('#textMarkup').show();
      });
    }
  });
});

},{"babel-runtime/core-js/json/stringify":3}],105:[function(require,module,exports){
'use strict';

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const { extendWith } = require("lodash");

// const { set } = require("lodash");

var $ = window.jQuery;

window.findADoctor = {
  hasBeenInitialized: false,
  enableGeoLookup: false,
  defaultFilter: {
    insurance: 'all',
    clinics: [],
    specializations: [],
    referrals: []
  },
  filter: {},
  searchLabel: {
    filter: Drupal.t('FILTERS'),
    clearall: Drupal.t('Clear all')
  },
  doctors: [],
  doctorsVisible: [],
  mapId: null,
  settings: {},
  maps: {},
  country: null,
  insuranceTypes: {},
  clinicTypes: {},
  specializationTypes: {},
  referralType: {},
  staticStrings: {},
  mapMarkerClusterer: null,
  markers: [],
  timer: null,
  externalLink: {
    title: Drupal.t('Open in a new tab', {}, { context: "External Link" }),
    accept: Drupal.t('OK', {}, { context: "External Link" }),
    cancel: Drupal.t('Cancel', {}, { context: "External Link" }),
    description: Drupal.t('This link opens in a new tab', {}, { context: "External Link" })

  },

  findGetParameter: function findGetParameter(parameterName) {
    var result = null;
    var tmp = [];
    window.location.search.substr(1).split('&').forEach(function (item) {
      tmp = item.split('=');
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
    return result;
  },


  /**
   * Set the list of doctors to put in the map.
   *
   * @param {array} doctors
   *   An array of doctor objects.
   * @param {string} country
   * @param {array} settings
   * @param {object} staticStrings
   * @param {object} filtering
   * @param {bool} enableGeoLookup
   */
  init: function init(doctors, country, settings, staticStrings, filtering, enableGeoLookup, otherDetails, listFieldsConfig, serachKeyword, default_mobile_view) {
    var _this = this;

    this.listFieldsConfig = listFieldsConfig;
    this.settings = settings;
    this.otherDetails = otherDetails;
    this.serachKeyword = serachKeyword;
    this.defaultView = default_mobile_view;
    var location = this.findGetParameter('address');
    if (location !== null) {
      $('input[name="map-search"]').val(location);
    } else {
      this.enableGeoLookup = enableGeoLookup;
    }

    if (!this.hasBeenInitialized) {
      this.hasBeenInitialized = true;

      this.doctorsVisible = this.doctors = doctors.filter(function (doctor) {
        return doctor.latitude && doctor.longitude;
      });

      this.country = country;

      if (staticStrings) {
        this.staticStrings = staticStrings;
      }

      if (filtering) {
        this.insuranceTypes = filtering.insurance;
        this.clinicTypes = filtering.clinic;
        this.specializationTypes = filtering.specialization;
        this.referralType = filtering.referral;

        this.resetFilter();
      }

      // Load the Google Map API scripts.
      // old Marker clusterer used: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js"
      $.getScript('https://cdn.jsdelivr.net/gh/googlemaps/js-marker-clusterer@gh-pages/src/markerclusterer.js').then(function () {
        $.getScript('https://maps.googleapis.com/maps/api/js?key=' + _this.settings.api_key + '&libraries=places&callback=initMaps&loading=async').then(function () {

          if (_this.serachKeyword) {
            $(".block-find-a-doctor .search-clear").css("display", "block");
            $('input[name="map-search2"]').val(_this.serachKeyword);
            $('.find-doctor__search-button').trigger('click');
          }

          if ($('input[name="map-search"]').attr('value') !== '') {
            $('[name="map-search-submit"]').trigger('click');
          }
        });
      });
    }
  },
  resetFilter: function resetFilter() {
    this.filter.clinics = [];
    this.filter.specializations = [];
    this.filter.insurance = 'all';
    this.filter.referrals = [];
  },


  /**
   * Add a map to the collection of maps.
   *
   * @param {string} mapId
   * @param {object} map
   */
  addMap: function addMap(mapId, map) {
    var _this2 = this;

    this.maps[mapId] = map;
    this.renderMapMarkers(mapId, this.doctors).then(function () {
      var options = {
        styles: [{
          textColor: 'transparent',
          url: '/sites/all/themes/alk/dist/assets/gfx/map-cluster.svg',
          height: 35,
          width: 35
        }]
      };

      google.maps.event.addListener(map, "dblclick", function (e) {
        window.dataLayer.push({
          event: "Manual Map Navigation",
          navigationInfo: {
            navigationAction: "Zoom In" // Drag Up, Drag Down, Drag Left, Drag Right, Zoom In, Zoom Out
          }
        });
      });

      google.maps.event.addListener(map, "rightclick", function (event) {
        var zoom = map.getZoom();
        setTimeout(function () {
          if (map.getZoom() != zoom) {
            // zooms are the same so they didn't double right click.
            window.dataLayer.push({
              event: "Manual Map Navigation",
              navigationInfo: {
                navigationAction: "Zoom Out" // Drag Up, Drag Down, Drag Left, Drag Right, Zoom In, Zoom Out
              }
            });
          }
        }, 300);
      });

      google.maps.event.addListener(map, 'dragstart', function () {
        window.dataLayer.push({
          event: "Manual Map Navigation",
          navigationInfo: {
            navigationAction: "Drag" // Drag Up, Drag Down, Drag Left, Drag Right, Zoom In, Zoom Out
          }
        });
      });

      // Add a marker clusterer to manage the markers.
      _this2.mapMarkerClusterer = new MarkerClusterer(_this2.maps[mapId], _this2.markers, options);

      // if ($('#pagination-find-doctor-list').length) {
      //alert('test');
      // this.renderFindDoctorList('find-doctor-list',this.doctors, this.otherDetails);
      //}


      // Center on the country selected in backend.
      _this2.searchMapFindoctor(mapId);

      // this.maps[mapId].addListener('mousedown', () => {
      //   console.log('mousedon');
      // })

      // this.maps[mapId].addListener('mouseup', () => {
      //   console.log('mouseup');
      // })


      _this2.maps[mapId].addListener('idle', function () {
        _this2.mapChanged(mapId);
      });
    });
  },


  /**
   * Do a search for a location. If a location is found, set and zoom on that point on the map.
   *
   * @param {string} mapId
   * @param {string} location // location string, etc. postal code, address, country, etc.
   */
  searchMapFindoctor: function searchMapFindoctor(mapId, location) {
    var _this3 = this;

    if (location) {
      window.dataLayer.push({
        event: "clinicSearch",
        searchInfo: {
          searchName: location // e.g. Copenhagen
        }
      });
      window.dataLayer.push({
        'event': 'FAD_Search',
        'search_text': location,
        'latest_location': location
      });
    }

    if (location === undefined) {
      var bounds = new google.maps.LatLngBounds();

      for (var i = 0; i < this.markers.length; i++) {
        bounds.extend(this.markers[i].getPosition());
      }

      this.maps[mapId].fitBounds(bounds);
    } else {
      location += ', ' + this.country; // always append country to location

      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'address': location }, function (results, status) {
        if (status.toLowerCase() === 'ok') {
          var _location = results[0].geometry.location;
          var viewport = results[0].geometry.viewport;
          _this3.maps[mapId].setCenter({ lat: _location.lat(), lng: _location.lng() });
          _this3.maps[mapId].fitBounds(viewport);
        }
      });
    }
  },


  /**
   * Reset the map to its default view.
   *
   * @param {string} mapId
   */
  resetMap: function resetMap(mapId) {
    if (mapId === undefined) {
      mapId = this.mapId;
    }

    this.searchMapFindoctor(mapId);
  },
  renderFindDoctorList: function renderFindDoctorList(name, doctors, otherDetails) {
    var container = $('#pagination-' + name);

    var options = {
      dataSource: doctors,
      pageSize: 10,
      pageNumber: 1,
      otherDetails: otherDetails,

      callback: function callback(response, pagination) {
        var pageNumber = pagination.pageNumber;
        var dataHtml = '<ul class="find-a-doctor-list">';
        var doctorIntroTitleMarkup = void 0;
        var doctorDetails = otherDetails;
        var referenceRequiredMarkup = '';
        //svg to img
        // <svg height="10px" width="10px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--! Font Awesome Free 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2022 Fonticons, Inc. --><path d="M365.3 93.38l-74.63-74.64C278.6 6.743 262.3 0 245.4 0L64-.0001c-35.35 0-64 28.65-64 64l.0065 384c0 35.35 28.65 64 64 64H320c35.2 0 64-28.8 64-64V138.6C384 121.7 377.3 105.4 365.3 93.38zM320 464H64.02c-8.836 0-15.1-7.163-16-15.1L48 64.13c-.0004-8.837 7.163-16 16-16h160L224 128c0 17.67 14.33 32 32 32h79.1v288C336 456.8 328.8 464 320 464z"/></svg>
        var referenceIcon = '<img src="/sites/all/themes/alk/dist/assets/img/icon_article.png">';
        $.each(response, function (index, doctor, otherDetails) {

          if (country != "Norge") {
            if (doctor.reference_required !== '0') {
              referenceRequiredMarkup = '\n                <div class="referral-needed">' + referenceIcon + '  ' + Drupal.t('REFERRAL NEEDED') + '</div>';
            } else if (doctor.reference_not_needed == '1') {
              referenceRequiredMarkup = '\n                <div class="referral-needed">' + referenceIcon + '  ' + Drupal.t('REFERRAL NOT NEEDED') + '</div>';
            } else {
              // comments from the client: the referral tag is needed on all doctors, despite the third checkbox.
              // Asana Ticket: 1203774045244391
              referenceRequiredMarkup = '\n                <div class="referral-needed">' + referenceIcon + '  ' + Drupal.t('REFERRAL NOT NEEDED') + '</div>';
            }
          }
          doctorIntroTitleMarkup = '<p class="doctor-intro__title">' + doctor.name;
          dataHtml += '\n            <li id="listAnchor-' + doctor.id + '" class="find-doctor__result-item"  data-page-number="' + pageNumber + '">\n            ' + referenceRequiredMarkup + '\n            <div class="doctor-intro">\n            ' + doctorIntroTitleMarkup + '\n              <div class="doctor-clinic">\n                <p class="doctor-clinic-name"> ' + doctor.clinic_name + '</p>\n                <p class="doctor-clinic-name">\n                  ' + doctorDetails.clinic.types.filter(function (clinic) {
            return doctor.clinic_types.includes(clinic.id);
          }).map(function (clinic) {
            return '' + clinic.name;
          }).join(', ') + '\n                </p>\n              </div>\n              <div class="doctor-specialization">\n                ' + doctorDetails.specialization.types.filter(function (specialization) {
            return doctor.clinic_specializations.includes(specialization.id);
          }).map(function (specialization) {
            return '' + specialization.name;
          }).join(', ') + '\n              </div> \n              <div class="doctor-department">' + doctor.department + ' </div>\n              <div class="doctor-intro__wrap">\n                <p class="doctor-address">\n                  ' + doctor.street_address + ' <br>\n                  ' + doctor.zipcode + ' ' + doctor.city + '\n                </p>\n              </div>\n            </div>\n            <div class="doctor-list-row">\n              <div class="column left">\n                ' + (doctor.link ? '<a class="button website website-popup" data-doctor="' + doctor.name + '" data-city="' + doctor.city + '"  doctor-link="' + doctor.link + '" target="_blank"> ' + Drupal.t('website') + '</a>' : '<p></p>') + '\n              </div>\n              <div class="column middle">\n                ' + (doctor.bookingLink ? '<a class="button booking website-popup" data-doctor="' + doctor.name + '" data-city="' + doctor.city + '" doctor-link="' + doctor.bookingLink + '" target="_blank" >' + Drupal.t('booking') + '</a>' : '<p></p>') + '\n              </div>\n              <div class="column right">\n                <a  href="' + doctor.node_link + '" target="_blank">\n                  <span data-doctor="' + doctor.name + '" data-city="' + doctor.city + '"  class="right-arrow">' + window.findADoctor.staticStrings.doctorItemLabels.readMoreLabel + '</span> <!-- // Asana ticket: 1203851500197804. -->\n                </a>\n              </div>\n            </div>\n            </li>\n          ';
        });

        dataHtml += '</ul>';
        container.prev().html(dataHtml);
      }
    };

    //$.pagination(container, options);

    container.addHook('beforeInit', function () {
      // window.console && console.log('beforeInit...');
    });
    container.pagination(options);

    container.addHook('beforePageOnClick', function (event) {
      var elementId = event.currentTarget.getAttribute("data-num");
      window.dataLayer.push({
        event: "Click - Pagination",
        paginationInfo: {
          paginationElement: "Page" + elementId
        }
      });
    });

    container.addHook('afterNextOnClick', function (event) {
      window.dataLayer.push({
        event: "Click - Pagination",
        paginationInfo: {
          paginationElement: "Next"
        }
      });
    });

    container.addHook('afterPreviousOnClick', function (event) {
      window.dataLayer.push({
        event: "Click - Pagination",
        paginationInfo: {
          paginationElement: "Previous"
        }
      });
    });

    return container;
  },


  // TODO: Markers function here instead of inside initMap function (and just call the function inside there?
  updateMapMarkerClusterer: function updateMapMarkerClusterer(mapId) {
    var _this4 = this;

    this.renderMapMarkers(this.maps[mapId], this.doctorsVisible).then(function () {
      _this4.mapMarkerClusterer.clearMarkers();
      _this4.mapMarkerClusterer.addMarkers(_this4.markers);
      google.maps.event.trigger(_this4.maps[mapId], 'resize');

      _this4.mapChanged(mapId);
      // this.renderFindDoctorList('find-doctor-list',this.doctorsVisible, this.otherDetails);
    });
  },
  insuranceTypeRadiobuttonFilter: function insuranceTypeRadiobuttonFilter() {

    if (typeof this.insuranceTypes.types == 'undefined' || typeof this.insuranceTypes.types == 'null' || !this.insuranceTypes.types.length) {
      return '';
    }

    return '\n    <div class="find-doctor__clinic-type">\n      <p class="title-filter">' + this.insuranceTypes.title + ' :</p>\n      <div class="filter-options--insurance-type">\n      ' + this.insuranceTypes.types.map(function (type) {
      return '\n          <div class="form-radiobutton">\n            <input class="clinic-insurance" data-name="' + type.name + '" type="radio" id="clinic-insurance_' + type.id + '" ' + (type.id === window.findADoctor.filter.insurance ? "checked" : "") + '  name="clinic-type" value="' + type.id + '" />\n            <label for="clinic-insurance_' + type.id + '">' + type.name + '</label>\n          </div>\n        ';
    }).join('') + '\n      </div>\n    </div>\n  ';
  },
  clinicTypeCheckboxFilter: function clinicTypeCheckboxFilter() {

    if (typeof this.clinicTypes.types == 'undefined' || typeof this.clinicTypes.types == 'null' || !this.clinicTypes.types.length) {
      return '';
    }
    return '\n      <div class="find-doctor__clinic-type">\n          <p class="title-filter">' + this.clinicTypes.title + ' :</p>\n    <div>\n    ' + this.clinicTypes.types.map(function (type) {
      return '\n        <div id="ck-button" class="filter-clinic-type">\n          <label>\n            <input class="clinic-type" name="clinictype" type="checkbox" value="' + type.id + '" ' + (jQuery.inArray(type.id, window.findADoctor.filter.clinics) !== -1 ? "checked" : "") + ' data-id="' + type.name + '"><span>' + type.name + '</span>\n          </label>\n        </div>\n      ';
    }).join('') + '\n    </div>\n    </div>\n    ';
  },
  specializationCheckboxFilter: function specializationCheckboxFilter() {
    if (typeof this.specializationTypes.types == 'undefined' || typeof this.specializationTypes.types == 'null' || !this.specializationTypes.types.length) {
      return '';
    }

    return '\n      <div class="find-doctor__specialization">\n        <p class="title-filter">' + this.specializationTypes.title + ' :</p>\n        <div class="filter-options--specialization">\n          ' + this.specializationTypes.types.map(function (type) {
      return '\n            <div id="ck-button" class="filter-specialization-type">\n              <label>\n                <input class="specialization-type" name="specializationstype" type="checkbox" value="' + type.id + '" ' + (jQuery.inArray(type.id, window.findADoctor.filter.specializations) !== -1 ? "checked" : "") + ' data-id="' + type.name + '"><span>' + type.name + '</span>\n              </label>\n            </div>\n            ';
    }).join('') + '\n        </div>\n      </div>\n    ';
  },
  referralCheckboxFilter: function referralCheckboxFilter() {
    if (typeof this.referralType.types == 'undefined' || typeof this.referralType.types == 'null' || !this.referralType.types.length) {
      return '';
    }

    return '\n      <div class="find-doctor__specialization">\n        <p class="title-filter">' + this.referralType.title + ' :</p>\n        <div class="filter-options--specialization">\n          ' + this.referralType.types.map(function (type) {
      return '\n            <div id="ck-button" class="filter-referral-type">\n              <label>\n                <input class="referral-type" name="referralstype" type="checkbox" value="' + type.id + '" ' + (jQuery.inArray(type.id, window.findADoctor.filter.referrals) !== -1 ? "checked" : "") + ' data-id="' + type.name + '"><span>' + type.name + '</span>\n              </label>\n            </div>\n            ';
    }).join('') + '\n        </div>\n      </div>\n    ';
  },
  renderMapMarkers: function renderMapMarkers(mapId, doctorArray) {
    // Add some markers to the map.
    // Note: The code uses the JavaScript Array.prototype.map() method to
    // create an array of markers based on a given "locations" array.
    // The map() method here has nothing to do with the Google Maps API.

    this.renderFindDoctorList('find-doctor-list', doctorArray, this.otherDetails);

    this.markers = doctorArray.map(function (doctor) {
      // Add marker icon
      var markerIcon = {
        url: '/sites/all/themes/alk/dist/assets/gfx/map-location.svg',
        scaledSize: new google.maps.Size(40, 40)
      };

      // Add anchor link
      var anchorLink = '#listAnchor-' + doctor.id;
      var marker = new google.maps.Marker({
        position: {
          lat: parseFloat(doctor.latitude),
          lng: parseFloat(doctor.longitude)
        },
        id: doctor.id,
        url: anchorLink,
        optimized: false,
        icon: markerIcon
      });

      marker['infoWindow'] = new google.maps.InfoWindow({ content: buildInfoWindowContent(doctor) });
      marker.setPosition({ lat: parseFloat(doctor.latitude), lng: parseFloat(doctor.longitude) });

      google.maps.event.addListener(marker, 'click', function () {

        //APW-392 - JIRA START
        //page observer
        function paginationPageObserver() {
          var paginationContainer = document.getElementById("pagination-find-doctor-list");
          ///console.log(paginationContainer);
          var targetNode = paginationContainer;
          var config = { childList: true, subtree: true };
          var callback = function callback(mutationsList, observer) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = (0, _getIterator3.default)(mutationsList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var mutation = _step.value;

                if (mutation.type === 'childList') {
                  mapEveryPage();
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          };
          var observer = new MutationObserver(callback);
          observer.observe(targetNode, config);
        }
        paginationPageObserver();

        var whileLoopCondition = false;
        var clickFirstPage = document.querySelectorAll(".J-paginationjs-page");
        clickFirstPage[0].click();

        function mapEveryPage() {
          //doctorlist element
          var doctorLists = document.querySelectorAll(".find-doctor__result-item");
          var doctorListsArray = [].concat((0, _toConsumableArray3.default)(doctorLists));
          //doctor card ID
          var cardDortorId = "listAnchor-" + marker.id;

          doctorListsArray.map(function (list, index) {
            var newIndex = index + 1;
            if (list.id == cardDortorId) {
              list.classList.add("active");
              whileLoopCondition = true;
              var parentContainer = document.getElementsByClassName("data-container");
              var targetNode = document.querySelectorAll(".find-doctor__result-item.active");

              parentContainer[0].scrollTo({
                top: targetNode[0].offsetTop - 140,
                behavior: 'smooth'
              });
            } else {
              list.classList.remove("active");
              if (newIndex == 10 && whileLoopCondition == false) {
                var pagination = $('#pagination-find-doctor-list');
                pagination.pagination('next');
              }
            }
          });
        }

        while (whileLoopCondition == false) {
          mapEveryPage();
        }
        //APW-392 - JIRA END


        window.dataLayer.push({
          event: "Click - Red Pin",
          doctorInfo: {
            doctorName: doctor.name, // Øre-næse-hals-læge v. Kongens Nytorv, Speciallæge Keyvan Maghsoudi
            doctorCity: doctor.city // Copenhagen
          }
        });

        // Scroll anchor list item into view and open
        if ($('.find-doctor__results-container').length) {
          var $current = $(marker.url);
          var $active = $('.find-doctor__result-item.is-active');
          var offset = void 0;

          if ($current.hasClass('is-active')) {
            $current.removeClass('is-active').find('.doctor-information').slideUp();
          } else {
            // collapse all expanded items if any
            if ($active.length) {
              $active.removeClass('is-active').find('.doctor-information').slideUp(function () {
                offset = $current.position().top;

                $current.addClass('is-active').find('.doctor-information').slideDown(function () {
                  $('.find-doctor__results-container').animate({ scrollTop: offset });
                });
              });
            } else {
              offset = $current.position().top;

              $current.addClass('is-active').find('.doctor-information').slideDown(function () {
                $('.find-doctor__results-container').animate({ scrollTop: offset });
              });
            }
          }
        }

        // close all infowindows
        for (var i = 0; i < window.findADoctor.markers.length; i++) {
          var currentMarker = window.findADoctor.markers[i];
          currentMarker['infoWindow'].close();
        }

        // open current markers infowindow
        this['infoWindow'].open(window.findADoctor.map, this);

        if ($('.gm-style-iw').length > 0) {
          window.findADoctor.styleInfowindow();
        } else {
          setTimeout(function () {
            window.findADoctor.styleInfowindow();
          }, 50);
        }
      });

      return marker;
    });

    return new _promise2.default(function (resolve, reject) {
      resolve();
    });
  },
  styleInfowindow: function styleInfowindow() {
    // Reference to the DIV which receives the contents of the infowindow using jQuery
    var iwOuter = $('.gm-style-iw');

    // Set max-height on info window inner div to activate scroll on large infowindows
    iwOuter.first().children(':first-child').addClass('iw-inner');

    /* The DIV we want to change is above the .gm-style-iw DIV.
     * So, we use jQuery and create a iwBackground variable,
     * and took advantage of the existing reference to .gm-style-iw for the previous DIV with .prev().
     */
    iwOuter.parent().addClass('iw__parent');

    var iwBackground = iwOuter.prev();
    // Removes background shadow DIV
    iwBackground.children(':nth-child(2)').css({ 'display': 'none' });
    // Removes arrow background
    iwBackground.children(':nth-child(3)').css({ 'display': 'none' });
    // Removes white background DIV
    iwBackground.children(':nth-child(4)').css({ 'display': 'none' });
    // Add class to customize arrow
    iwBackground.children(':first-child').addClass('iw-marker-arrow');

    // Reference to the div that groups the close button elements.
    var iwCloseBtn = iwOuter.next();
    // Apply the desired effect to the close button
    iwCloseBtn.css({ opacity: '1', right: '10px', top: '25px' });

    if ($('.iw-inner').height() < 200) {
      $('.iw-bottom-gradient').css({ display: 'none' });
    }
  },
  filterChanged: function filterChanged(mapId) {
    var _this5 = this;

    this.doctorsVisible = this.doctors.filter(function (elm) {
      if (elm.visible === false) {
        return false;
      }
      var insurance = _this5.filter.insurance === undefined || _this5.filter.insurance === null || _this5.filter.insurance === elm.insurance_type || _this5.filter.insurance === 'all';

      var clinics = false;
      if (_this5.filter.clinics !== undefined && _this5.filter.clinics !== null && _this5.filter.clinics.length > 0) {
        elm.clinic_types.map(function (item) {
          if (_this5.filter.clinics.includes(item)) {
            clinics = true;
          }
        });
      } else {
        clinics = true;
      }

      var specializations = false;
      if (_this5.filter.specializations !== undefined && _this5.filter.specializations !== null && _this5.filter.specializations.length > 0) {
        elm.clinic_specializations.map(function (item) {
          if (_this5.filter.specializations.includes(item)) {
            specializations = true;
          }
        });
      } else {
        specializations = true;
      }

      var referrals = false;
      if (_this5.filter.referrals !== undefined && _this5.filter.referrals !== null && _this5.filter.referrals.length > 0) {
        if (_this5.filter.referrals.includes(elm.reference_required)) {
          referrals = true;
        }
      } else {
        referrals = true;
      }

      return insurance && clinics && specializations && referrals;
    });

    // TODO: Add changes to map (markers) as well in initMap const markers (add a function above? – see other TODO)

    this.updateMapMarkerClusterer(mapId);
  },
  mapChanged: function mapChanged(mapId) {
    var _this6 = this;

    var markersVisible = [];
    var bounds = this.maps[mapId].getBounds();
    var zoom = this.maps[mapId].getZoom();
    var lat = this.maps[mapId].center.lat();
    var lng = this.maps[mapId].center.lng();

    this.doctors.sort(function (a, b) {
      var diffA = a.score / (1 + _this6.geolocationDistance(a.latitude, a.longitude, lng, lat) / 1000);
      var diffB = b.score / (1 + _this6.geolocationDistance(b.latitude, b.longitude, lng, lat) / 1000);

      if (diffA < diffB) {
        return 1;
      } else if (diffA > diffB) {
        return -1;
      } else {
        return 0; // same
      }
    });

    if (bounds !== null && this.markers.length > 0) {
      for (var i = 0; i < this.markers.length; i++) {
        if (bounds.contains(this.markers[i].getPosition())) {
          // map contains marker
          markersVisible.push(this.markers[i].id);
        }
      }

      // zoom out until at least a marker is visible
      if (markersVisible.length < 1) {
        zoom--;
        this.maps[mapId].setOptions({ zoom: zoom });
      }
      //this.doctors = [];
      var searchDoctors = [];
      for (var _i = 0; _i < this.doctors.length; _i++) {
        if (markersVisible.includes(this.doctors[_i].id)) {
          searchDoctors.push(this.doctors[_i]);
        } else {

          searchDoctors.splice(_i, 1);
        }
      }
      //put this here to make no repeat for first load jf the page.
      this.renderFindDoctorList('find-doctor-list', searchDoctors, this.otherDetails);
    }
  },

  //function for doctor cards when clicked
  cardDoctorListClicked: function cardDoctorListClicked() {
    //  collection of doctor per page. type of data collected "object"
    var matches = document.querySelectorAll(".find-doctor__result-item");
    matches.forEach(function (matche) {
      /*
       * https://www.30secondsofcode.org/articles/s/javascript-arrow-function-event-listeners
       */
      matche.addEventListener('click', function (e) {
        //remove active class to the child element
        matches.forEach(function (matche) {
          matche.classList.remove("active");
        });

        //make doctor card active
        matche.classList.add("active");

        var stringWithDoctorID = e.currentTarget.getAttribute('id');
        var splittedString = stringWithDoctorID.split('-');
        var doctorLiId = splittedString.slice(-1);
        var doctorStringID = doctorLiId[0];
        var doctorsDetails = [].concat((0, _toConsumableArray3.default)(window.findADoctor.doctors));
        //map container id
        var mapID = 'map_list';

        doctorsDetails.map(function (doctor) {
          if (doctorStringID === doctor.id) {
            var svgMarker = {
              url: "/sites/all/themes/alk/dist/assets/gfx/map-location.svg",
              scaledSize: new google.maps.Size(50, 50) // scaled size //control to resize the marker in the map
            };

            var contentString = '<div id="content">' + '<div id="siteNotice">' + '</div>' + ('<strong style="color: #ff6651;">' + doctor.name + '</strong>') + '<div id="bodyContent">' + ('<p style="margin-bottom: 0px; color: #a9a9a9;">' + doctor.clinic_name + '</p>') + ('<p style="margin-bottom: 0px; color: #a9a9a9;">' + doctor.street_address + '</p>') + ('<p style="color: #a9a9a9;">' + doctor.zipcode + ' ' + doctor.city + '</p>') +
            // Asana ticket: 1203851500197804.
            //use ${window.findADoctor.staticStrings.doctorItemLabels.readMoreLabel} to effect the google translate language
            //`<a href="${doctor.node_link}" doctor-name="${doctor.name}" data-city="${doctor.city}" class="iw__doctor-link" target="_blank" style="color: #ff6651;">${window.findADoctor.staticStrings.doctorItemLabels.readMoreLabel}</a>` +
            '</div>';
            var latitude = parseFloat(doctor.latitude);
            var longitude = parseFloat(doctor.longitude);
            var latLang = { lat: latitude, lng: longitude };

            //marker dialog above the marker
            var infoWindow = new google.maps.InfoWindow();
            infoWindow.setContent(contentString);
            infoWindow.setPosition(latLang);
            //contorl the position of the dialog above the marker in the map
            infoWindow.setOptions({
              pixelOffset: new google.maps.Size(0, -250)
            });

            // The map, centered base in latLang
            var map = new google.maps.Map(document.getElementById(mapID), {
              zoom: 18,
              center: latLang,
              //remove map and satalite tab on top left
              mapTypeControl: false
            });

            // The marker, positioned
            var doctorMapMarker = new google.maps.Marker({
              position: latLang,
              map: map,
              icon: svgMarker
            });

            //listerner when the marker is clicked
            doctorMapMarker.addListener("click", function () {
              infoWindow.open(map);
            });

            //auto click the marker to show the dialog above the marker once the doctor card clicked
            new google.maps.event.trigger(doctorMapMarker, 'click');
          }
        });
      });
    });
  },


  /**
  * Calc distance between geolocation.
  *
  * @param {number} latitudeFrom
  * @param {number} longitudeFrom
  * @param {number} latitudeTo
  * @param {number} longitudeTo
  * @return {number}
  */

  geolocationDistance: function geolocationDistance(latitudeFrom, longitudeFrom, longitudeTo, latitudeTo) {
    // convert from degrees to radians
    var latFrom = this.deg2rad(latitudeFrom);
    var lonFrom = this.deg2rad(longitudeFrom);
    var latTo = this.deg2rad(latitudeTo);
    var lonTo = this.deg2rad(longitudeTo);

    var latDelta = latTo - latFrom;
    var lonDelta = lonTo - lonFrom;

    var angle = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(latDelta / 2), 2) + Math.cos(latFrom) * Math.cos(latTo) * Math.pow(Math.sin(lonDelta / 2), 2)));
    return angle;
  },
  deg2rad: function deg2rad(degrees) {
    var pi = Math.PI;
    return degrees * (pi / 180);
  }
};

/**
 * Build HTML for the info window for a doctor.
 *
 * @param {object} doctor
 * @return {string}
 */
var buildInfoWindowContent = function buildInfoWindowContent(doctor) {
  var linkMarkup = doctor.node_link ? '<a href="' + doctor.node_link + '" doctor-name="' + doctor.name + '" data-city="' + doctor.city + '" target="_blank" class="iw__doctor-link">' + window.findADoctor.staticStrings.doctorItemLabels.readMoreLabel + '</a>' : '';

  var doctorIntroTitleMarkup = void 0;
  if (doctor.entity_type === 'clinic') {
    doctorIntroTitleMarkup = '<p class="iw__doctor-name"><strong>' + doctor.clinic_name + '</strong><br>' + doctor.name + '</p>';
  } else {
    doctorIntroTitleMarkup = '<p class="iw__doctor-name"><strong>' + doctor.name + '</strong>';
    doctorIntroTitleMarkup += doctor.clinic_name !== '' ? '<br>' + doctor.clinic_name : '';
    doctorIntroTitleMarkup += '</p>';
  }

  return '\n    <div class="iw__container">\n      <div class="iw__doctor-content">\n        ' + doctorIntroTitleMarkup + '\n        ' + doctor.street_address + '</br>\n        ' + doctor.zipcode + ' ' + doctor.city + '\n        <!-- ' + linkMarkup + ' --> <!-- Asana ticket: 1203851500197804.  -->\n      </div>\n      <div class="btn-button">\n\n      </div>\n    </div>\n\n    <div class="iw-bottom-gradient"></div>\n  ';
};

window.initMaps = function () {

  var mapContainers = document.getElementsByName('googleMap');

  Array.prototype.forEach.call(mapContainers, function (map) {
    var mapId = map.getAttribute('id');
    var googleMap = new google.maps.Map(map, {
      gestureHandling: 'cooperative',
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      zoom: 20,
      minZoom: 1,
      maxZoom: 19
    });

    var options = {
      componentRestrictions: { country: window.country_code },
      fields: ["address_components", "geometry", "icon", "name"],
      strictBounds: false
    };

    var inputMobile = document.getElementById(mapId + "-input-mobile");
    var searchBoxMobile = new google.maps.places.Autocomplete(inputMobile, options);

    var input = document.getElementById(mapId + "-input");
    var searchBox = new google.maps.places.Autocomplete(input, options);

    searchBoxMobile.addListener("place_changed", function () {
      window.findADoctor.searchMapFindoctor(mapId, inputMobile.value);
    });

    searchBox.addListener("place_changed", function () {
      window.findADoctor.searchMapFindoctor(mapId, input.value);
    });

    window.findADoctor.mapId = mapId;
    window.findADoctor.addMap(mapId, googleMap);

    if (window.findADoctor.enableGeoLookup) {
      // storing data as local storage insted of cookies.
      // let savedCountry = getCookie('fadCountry=');
      // let savedCity = getCookie('fadCity=');
      var savedCountry = localStorage.getItem("fadCountry");
      var savedCity = localStorage.getItem("fadCity");
      if (savedCountry !== undefined && savedCountry !== null && savedCity !== undefined && savedCity !== null) {
        countryMap(savedCountry, savedCity);
      } else {
        // Look up location from IP
        // fetch('https://extreme-ip-lookup.com/json/')
        window.fetch('https://api.ipstack.com/check?access_key=771c7cd15b294eb19b2e29264ff2b8c2').then(function (response) {
          return response.ok ? response.json() : undefined;
        }).then(function (response) {
          if (response) {
            countryMap(response.country_name, response.city);
            // Asana task: 1205223153870117.
            // document.cookie = `fadCountry=` + response.country_name + `; max-age=3600;`
            // document.cookie = `fadCity=` + response.city + `; max-age=3600;`
            localStorage.setItem("fadCountry", response.country_name);
            localStorage.setItem("fadCity", response.city);
          }
        });
      }
    }
  });
};

function countryMap(country, city) {
  var countryMap = {
    DE: 'Germany',
    DK: 'Denmark',
    FI: 'Finland',
    FR: 'France',
    IT: 'Italy',
    US: 'United States',
    NL: 'Netherlands',
    NO: 'Norway'
  };
  if (countryMap[window.country_code] === country) {
    window.findADoctor.searchMapFindoctor(window.findADoctor.mapId, city);
  }
}

function getCookie(name) {
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookies = decodedCookie.split(';');
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.indexOf(name) == 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
}

(function ($) {
  $(function () {

    if ($('.tabs').css('display') !== 'none') {
      // $("#two-panel").css({'z-index': '0', 'height': '20px', 'Opacity':'0'});
      $("#one-panel").css({ 'z-index': '100', 'position': 'absolute' });
      $("#two-panel").css({ 'z-index': '0', 'Opacity': '0' });

      $("#two-tab").on('click', function () {
        $("#one-panel").css({ 'z-index': '0', 'position': 'absolute' });
        $("#two-panel").css({ 'z-index': '100', 'Opacity': 'inherit', 'height': 'inherit' });
        // $("#two-panel").css('display', 'unset');
      });

      $("#one-tab").on('click', function () {
        $("#one-panel").css({ 'z-index': '100', 'position': 'absolute' });
        $("#two-panel").css({ 'z-index': '0', 'Opacity': '0' });
      });
    }

    $('[name="map-search-doctor-submit"]').on('click', function () {
      var mapId = $(this).data('map-id');
      var searchValue = $('[name="map-search"][data-map-id="' + mapId + '"]').val();
      var searchValue2 = $('#map_list-input').val();
      if (searchValue2) {
        window.findADoctor.searchMapFindoctor(mapId, searchValue2);
      } else {
        window.findADoctor.searchMapFindoctor(mapId);
      }
    });

    $('[name="map-search"]').on('keypress', function (e) {
      $('[name="map-search-doctor-submit"]').trigger('click');
    });

    $(document).on('click', '.search-clear', function (event) {
      $("#map_list-input").val("");
      $(".block-find-a-doctor .search-clear").css("display", "none");
      $('[name="map-search-doctor-submit"]').trigger('click');
    });

    $("#map_list-input").on("change paste keyup", function () {
      $(".block-find-a-doctor .search-clear").css("display", "block");
    });

    $('.search-clear-mobile').css('cursor', 'pointer');
    $(document).on('click', '.search-clear-mobile', function (event) {
      $("#map_list-input-mobile").val("");
      $(".block-find-a-doctor .search-clear-mobile").css("display", "none");
      $('[name="map-search-doctor-submit"]').trigger('click');
    });

    $('.search-clear-mobile').on('click touchstart', function () {
      $("#map_list-input-mobile").val("");
      $(".block-find-a-doctor .search-clear-mobile").css("display", "none");
      $('[name="map-search-doctor-submit"]').trigger('click');
    });

    $("#map_list-input-mobile").on("change paste keyup", function () {
      $(".block-find-a-doctor .search-clear-mobile").css("display", "block");
    });

    $(document).on('click', '.clinic_list', function (event) {
      var el = $(event.target.attributes[1]);
      var val = el.val();
      var mapId = 'map_list'; // TODO: find dynamically
      $("[data-value=" + val + "]").remove();
      window.findADoctor.filter.clinics.splice($.inArray(val, window.findADoctor.filter.clinics), 1);
      window.findADoctor.filterChanged(mapId);
    });

    $(document).on('click', '.insurance_list', function (event) {
      var el = $(event.target.attributes[1]);
      var val = el.val();
      var mapId = 'map_list'; // TODO: find dynamically
      window.findADoctor.filter.insurance = val;
      $("[data-value=" + val + "]").remove();
      window.findADoctor.filter.insurance = 'all';
      window.findADoctor.filterChanged(mapId);
    });

    $(document).on('click', '.specializations_list', function (event) {
      var el = $(event.target.attributes[1]);
      var val = el.val();
      var mapId = 'map_list'; // TODO: find dynamically
      $("[data-value=" + val + "]").remove();
      window.findADoctor.filter.specializations.splice($.inArray(val, window.findADoctor.filter.specializations), 1);
      window.findADoctor.filterChanged(mapId);
    });

    $(document).on('click', '.referrals_list', function (event) {
      var el = $(event.target.attributes[1]);
      var val = el.val();
      var mapId = 'map_list'; // TODO: find dynamically
      $("[data-value=" + val + "]").remove();
      window.findADoctor.filter.referrals.splice($.inArray(val, window.findADoctor.filter.referrals), 1);
      window.findADoctor.filterChanged(mapId);
    });

    if ($(window).width() < 500) {
      $("#ui-id-1").addClass('ui-widget-full');
      $('.ui-dialog').css("top", "60%");
      // $('.ui-dialog-content').css( "height", "200px !important" );
      $('.ui-dialog-content').height($(".ui-dialog-content").height() + 20);
    }

    function showAndOut() {

      //current browser view port width
      var $width = $(window).width();
      //copy of markup to append
      var $markupCopy = $('.find-a-doctor__results-container');

      //where to appent the $markupCopy
      var $targetToAppendMobile = $('.block-find-a-doctor');
      var $targetToAppendDesktop = $('#one-panel');

      //append below 768 viewport
      if ($width <= 768 && $markupCopy.length === 1) {
        //console.log('running')
        $($targetToAppendMobile[0].children[0]).after($markupCopy[0]);
      } else {
        $targetToAppendDesktop[0].children[0].after($markupCopy[0]);
      }
    }

    function cardDoctorObserver() {
      var dataContainer = document.getElementsByClassName("data-container");
      var targetNode = dataContainer[0];
      var config = { childList: true, subtree: true };
      var callback = function callback(mutationsList, observer) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = (0, _getIterator3.default)(mutationsList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var mutation = _step2.value;

            if (mutation.type === 'childList') {
              window.findADoctor.cardDoctorListClicked(); //if Elements have changed do this
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      };
      var observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
    }
    /**
     * show and out of @class "find-a-doctor__results-container" in DOM
     */
    var isExist = $('.find-a-doctor__results-container').length;
    if (isExist) {
      showAndOut();
      //this will be run once the browser viewport width is change
      $(window).resize(function () {
        showAndOut();
      });
      cardDoctorObserver();
    }

    //APW-388 FaD 3.0 page type: mobile - landing on map
    function getCurrentUrlAndClickTarget(defaultView) {
      var $list = document.getElementById("one-tab");
      var $map = document.getElementById("two-tab");
      if (defaultView === 'map') {
        $map.click();
      } else {
        $list.click();
      }
    }

    getCurrentUrlAndClickTarget(window.findADoctor.defaultView);
  });
})(window.jQuery);

(function ($, Drupal, drupalSettings) {
  $(function () {

    function showmodal() {
      if (country == "Norge") {
        var content = '<div>' + window.findADoctor.insuranceTypeRadiobuttonFilter() + '' + window.findADoctor.clinicTypeCheckboxFilter() + '' + window.findADoctor.specializationCheckboxFilter() + '</div>';
      } else {
        var content = '<div>' + window.findADoctor.insuranceTypeRadiobuttonFilter() + '' + window.findADoctor.clinicTypeCheckboxFilter() + '' + window.findADoctor.specializationCheckboxFilter() + window.findADoctor.referralCheckboxFilter() + '</div>';
      }
      var confirmationDialog = Drupal.dialog(content, {
        dialogClass: 'confirm-dialog',
        resizable: false,
        closeOnEscape: false,
        width: 380,
        title: window.findADoctor.searchLabel.filter,
        open: function open(event, ui) {
          $('html, body').css('overflow', 'hidden'); //this line does the actual hiding
        },
        close: function close() {
          $('html, body').css('overflow', 'auto');
        },
        buttons: [{
          text: Drupal.t('Apply'),
          class: 'button btn-appy',
          click: function click() {
            var mapId = 'map_list'; // TODO: find dynamically
            $('.insurance_list').parent().remove();
            $('.clinic-insurance:checked').each(function (event) {
              var $this = $(this);
              window.findADoctor.filter.insurance = $(this).val();
              $(".filter_list_data").append("<li data-value=" + $(this).val() + ">" + $this[0].getAttribute('data-name') + " <a class='insurance_list' data-value=" + $(this).val() + ">x</a></li>");
            });

            //Clinic row
            var clinicOptions = $('[name="clinictype"]');
            var clText = [];
            $.each(clinicOptions, function () {
              var $this = $(this);
              var mapId = 'map_list';
              if ($this.is(":checked")) {
                if (jQuery.inArray($this.val(), window.findADoctor.filter.clinics) == -1) {
                  window.findADoctor.filter.clinics.push($this.val());
                  clText.push($this.data('id'));
                  $(".filter_list_data").append("<li data-value=" + $this.val() + ">" + $this.data('id') + " <a class='clinic_list' data-value=" + $this.val() + " >x</a></li>");
                }
              } else {
                if (jQuery.inArray($this.val(), window.findADoctor.filter.clinics) !== -1) {
                  var idx = window.findADoctor.filter.clinics.indexOf($this.val());
                  $("li[data-value=" + $this.val() + "]").remove();
                  if (idx > -1) {
                    window.findADoctor.filter.clinics.splice(idx, 1);
                    clText.splice(idx, 1);
                  }
                }
              }
            });

            //Clinic specializations row
            var specializationsOptions = $('[name="specializationstype"]');
            $.each(specializationsOptions, function () {
              var $this = $(this);
              var mapId = 'map_list';
              if ($this.is(":checked")) {
                if (jQuery.inArray($this.val(), window.findADoctor.filter.specializations) == -1) {
                  window.findADoctor.filter.specializations.push($this.val());
                  $(".filter_list_data").append("<li data-value=" + $this.val() + ">" + $this.data('id') + " <a class='specializations_list' data-value=" + $this.val() + " >x</a></li>");
                }
              } else {
                if (jQuery.inArray($this.val(), window.findADoctor.filter.specializations) !== -1) {
                  var idx = window.findADoctor.filter.specializations.indexOf($this.val());
                  $("li[data-value=" + $this.val() + "]").remove();
                  if (idx > -1) {
                    window.findADoctor.filter.specializations.splice(idx, 1);
                  }
                }
              }
            });

            //Referrals row
            var referralsOptions = $('[name="referralstype"]');
            var refText = [];
            $.each(referralsOptions, function () {
              var $this = $(this);
              var mapId = 'map_list';
              if ($this.is(":checked")) {
                if (jQuery.inArray($this.val(), window.findADoctor.filter.referrals) == -1) {
                  window.findADoctor.filter.referrals.push($this.val());
                  refText.push($this.data('id'));
                  $(".filter_list_data").append("<li data-value=" + $this.val() + ">" + $this.data('id') + " <a class='referrals_list' data-value=" + $this.val() + " >x</a></li>");
                }
              } else {
                if (jQuery.inArray($this.val(), window.findADoctor.filter.referrals) !== -1) {
                  var idx = window.findADoctor.filter.referrals.indexOf($this.val());
                  $("li[data-value=" + $this.val() + "]").remove();
                  if (idx > -1) {
                    window.findADoctor.filter.referrals.splice(idx, 1);
                    refText.splice(idx, 1);
                  }
                }
              }
            });
            var clString = clText ? clText.join(',') : '';
            var refString = refText ? refText.join(',') : '';
            window.dataLayer.push({
              'event': 'FAD_FilterApplied',
              'filters_applied': 'clinic: ' + clString + ' referrals: ' + refString
            });
            window.findADoctor.filterChanged(mapId);
            $('html, body').css('overflow', 'auto');
            confirmationDialog.close();
          }
        }, {
          text: window.findADoctor.searchLabel.clearall,
          class: 'button btn-clear',
          click: function click() {
            var mapId = 'map_list';
            $('html, body').css('overflow', 'auto');
            $(".filter_list_data").empty();
            window.findADoctor.resetFilter();
            window.findADoctor.filterChanged(mapId);
            confirmationDialog.close();
          }
        }],
        beforeClose: false
      });

      confirmationDialog.showModal();
    }

    function ConfirmDialog(doctorlink) {
      $('<div ></div>').appendTo('body').html('<div class="external-link" id="external-link"><div \n      class="external-link__content"><h3 class="external-link__title">' + window.findADoctor.externalLink.title + ' </h3> \n      <p class="external-link__description">' + window.findADoctor.externalLink.description + '</p> \n      <div class="external-link__buttons"><button class="button external-link__button external-link__button--cancel">' + window.findADoctor.externalLink.cancel + '</button> \n      <button class="button external-link__button external-link__button--accept" doctorlink=\'' + doctorlink + '\'>' + window.findADoctor.externalLink.accept + '</button></div></div></div>');
    };

    $(".show-popup").on('click', function () {
      showmodal();
    });

    $(".find-doctor__search-button").on('click', function () {

      var searchValue = $('[name="map-search2"][data-map-id="map_list"][id="map_list-input"]').val();

      if (searchValue) {
        var items = (0, _values2.default)(searchValue);
      } else {
        //return null
      }
    });

    $(".btn-filter").on('click', function () {
      window.dataLayer.push({
        event: "filterClick"
      });
      window.dataLayer.push({
        event: "FAD_FilterClick"
      });
    });

    $(document).on('click', '.website', function (event) {
      window.dataLayer.push({
        event: "Click - Website",
        doctorInfo: {
          doctorName: event.currentTarget.getAttribute("data-doctor"),
          doctorCity: event.currentTarget.getAttribute("data-city")
        }
      });
      window.dataLayer.push({
        event: "FAD_WebsiteClick",
        doctorInfo: {
          doctorName: event.currentTarget.getAttribute("data-doctor"),
          doctorCity: event.currentTarget.getAttribute("data-city"),
          latest_location: event.currentTarget.getAttribute("data-city")
        }
      });
    });

    $(document).on('click', '.booking', function (event) {
      window.dataLayer.push({
        event: "Click - Booking",
        doctorInfo: {
          doctorName: event.currentTarget.getAttribute("data-doctor"),
          doctorCity: event.currentTarget.getAttribute("data-city")
        }
      });
      window.dataLayer.push({
        event: "FAD_BookClick",
        doctorInfo: {
          doctorName: event.currentTarget.getAttribute("data-doctor"),
          doctorCity: event.currentTarget.getAttribute("data-city")
        }
      });
    });

    // Mouse over Engagement tracking
    $(document).one("mouseover", ".paginationjs .paginationjs-pages .paginationjs-page", function (event) {
      window.dataLayer.push({
        event: "Hover",
        hoverElement: {
          hoverElement: "Pagination"
        }
      });
    });

    $(document).one("mouseover", ".paginationjs .paginationjs-pages .paginationjs-prev ", function (event) {
      window.dataLayer.push({
        event: "Hover",
        hoverElement: {
          hoverElement: "Pagination"
        }
      });
    });

    $(document).one("mouseover", ".paginationjs .paginationjs-pages .paginationjs-prev ", function (event) {
      window.dataLayer.push({
        event: "Hover",
        hoverElement: {
          hoverElement: "Pagination"
        }
      });
    });

    $(document).one("mouseover", ".booking", function (event) {
      window.dataLayer.push({
        event: "Hover",
        hoverElement: {
          hoverElement: "Booking"
        }
      });
    });

    $(document).one("mouseover", ".website", function (event) {
      window.dataLayer.push({
        event: "Hover",
        hoverElement: {
          hoverElement: "Website"
        }
      });
    });

    // $(document).one("mouseover", ".btn-filter", function (event) {
    //   window.dataLayer.push({
    //     event: "Hover",
    //     hoverElement: {
    //       hoverElement: "Filter",
    //     },
    //   });
    // });

    $(document).one("mouseover", "#map_list-input", function (event) {
      window.dataLayer.push({
        event: "Hover",
        hoverElement: {
          hoverElement: "Location Search"
        }
      });
    });

    $(document).one("mouseover", "#map_list", function (event) {
      window.dataLayer.push({
        event: "Hover",
        hoverElement: {
          hoverElement: "Map"
        }
      });
    });

    $(document).on('click', '.iw__doctor-link', function (event) {
      window.dataLayer.push({
        event: "Click - Read More - On Map",
        doctorInfo: {
          doctorName: event.currentTarget.getAttribute("doctor-name"),
          doctorCity: event.currentTarget.getAttribute("data-city")
        }
      });

      window.dataLayer.push({
        event: "FAD_DoctorDetailClick",
        doctorInfo: {
          doctorName: event.currentTarget.getAttribute("doctor-name"),
          doctorCity: event.currentTarget.getAttribute("data-city"),
          latest_location: event.currentTarget.getAttribute("data-city")
        }
      });
    });

    $(document).on('click', '[title="Zoom out"]', function (event) {
      window.dataLayer.push({
        event: "Manual Map Navigation",
        navigationInfo: {
          navigationAction: "Zoom Out" // Drag Up, Drag Down, Drag Left, Drag Right, Zoom In, Zoom Out
        }
      });
    });

    $(document).on('click', '[title="Zoom in"]', function (event) {
      window.dataLayer.push({
        event: "Manual Map Navigation",
        navigationInfo: {
          navigationAction: "Zoom In" // Drag Up, Drag Down, Drag Left, Drag Right, Zoom In, Zoom Out
        }
      });
    });

    $(document).on('click', '.right-arrow', function (event) {

      window.dataLayer.push({
        event: "Click - Read More - In List",
        doctorInfo: {
          doctorName: event.currentTarget.getAttribute("data-doctor"),
          doctorCity: event.currentTarget.getAttribute("data-city")
        }
      });
      window.dataLayer.push({
        event: "FAD_DoctorDetailClick",
        doctorInfo: {
          doctorName: event.currentTarget.getAttribute("data-doctor"),
          doctorCity: event.currentTarget.getAttribute("data-city"),
          latest_location: event.currentTarget.getAttribute("data-city")
        }
      });
    });

    // Asana Ticket: 1202552901587025.
    $(document).on('click', '.find-a-doctor-list .find-doctor__result-item', function (event) {
      window.dataLayer = window.dataLayer || [];
      // dataLayer.push({
      //   event: "Click - Clinic card - In List",
      //   doctorInfo: {
      //     doctorName: event.currentTarget.querySelector('.doctor-list-row a').getAttribute("data-doctor"),
      //     doctorCity: event.currentTarget.querySelector('.doctor-list-row a').getAttribute("data-city")
      //   }
      // });
      dataLayer.push({
        event: "FAD_DoctorListViewed",
        latest_location: event.currentTarget.querySelector('.doctor-list-row a').getAttribute("data-city")
      });
      // Asana Ticket: 1203851500197804.
      if (window.country_code && window.country_code != "FI") {
        $("#map_list").prop("style", 'position: relative; overflow: hidden; pointer-events: none;');
      }
    });

    // Asana Ticket: 1203851500197804.
    if (window.country_code && window.country_code != "FI") {
      $("#map_list").prop("style", 'position: relative; overflow: hidden; pointer-events: none;');
    }
    $(".block-find-a-doctor .tabs #one-tab").trigger("click"); // mobile
    $(".block-find-a-doctor .tabs").hide(); // mobile


    $(document).on('click', '.website-popup', function (event) {
      var dactorlink = event.currentTarget.getAttribute("doctor-link");
      ConfirmDialog(dactorlink);
    });

    $(document).on('click', '.external-link__button--cancel', function (event) {
      $(".external-link").remove();
    });
    $(document).on('click', '.external-link__button--accept', function (event) {
      var win = window.open(event.currentTarget.getAttribute("doctorlink"), '_blank');
      win.focus();
    });
  });
})(jQuery, Drupal, drupalSettings);

},{"babel-runtime/core-js/get-iterator":2,"babel-runtime/core-js/object/values":4,"babel-runtime/core-js/promise":5,"babel-runtime/helpers/toConsumableArray":8}],106:[function(require,module,exports){
'use strict';

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = window.jQuery;

window.findDoctor = {
  hasBeenInitialized: false,
  enableGeoLookup: false,
  defaultFilter: {
    insurance: 'all',
    clinics: [],
    specializations: []
  },
  filter: {},
  doctors: [],
  doctorsVisible: [],
  mapId: null,
  settings: {},
  maps: {},
  country: null,
  insuranceTypes: {},
  clinicTypes: {},
  specializationTypes: {},
  staticStrings: {},
  mapMarkerClusterer: null,
  markers: [],
  timer: null,

  findGetParameter: function findGetParameter(parameterName) {
    var result = null;
    var tmp = [];

    window.location.search.substr(1).split('&').forEach(function (item) {
      tmp = item.split('=');
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
    return result;
  },


  /**
   * Set the list of doctors to put in the map.
   *
   * @param {array} doctors
   *   An array of doctor objects.
   * @param {string} country
   * @param {array} settings
   * @param {object} staticStrings
   * @param {object} filtering
   * @param {bool} enableGeoLookup
   */
  init: function init(doctors, country, settings, staticStrings, filtering, enableGeoLookup, otherDetails, listFieldsConfig) {
    var _this = this;

    this.listFieldsConfig = listFieldsConfig;
    this.settings = settings;
    this.otherDetails = otherDetails;
    var location = this.findGetParameter('address');
    if (location !== null) {
      $('input[name="map-search"]').val(location);
    } else {
      this.enableGeoLookup = enableGeoLookup;
    }

    if (!this.hasBeenInitialized) {
      this.hasBeenInitialized = true;

      this.doctorsVisible = this.doctors = doctors.filter(function (doctor) {
        return doctor.latitude && doctor.longitude;
      });

      this.country = country;

      if (staticStrings) {
        this.staticStrings = staticStrings;
      }

      if (filtering) {
        this.insuranceTypes = filtering.insurance;
        this.clinicTypes = filtering.clinic;
        this.specializationTypes = filtering.specialization;

        this.resetFilter();
      }

      // Load the Google Map API scripts.
      // old Marker clusterer used: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js"
      $.getScript('https://cdn.jsdelivr.net/gh/googlemaps/js-marker-clusterer@gh-pages/src/markerclusterer.js').then(function () {
        $.getScript('https://maps.googleapis.com/maps/api/js?key=' + _this.settings.api_key + '&libraries=places&callback=initMap&loading=async').then(function () {
          if ($('input[name="map-search"]').attr('value') !== '') {
            $('[name="map-search-submit"]').trigger('click');
          }
        });
      });
    }
  },
  resetFilter: function resetFilter() {
    this.filter.clinics = this.defaultFilter.clinics;
    this.filter.specializations = this.defaultFilter.specializations;
    this.filter.insurance = 'all';
  },


  /**
   * Add a map to the collection of maps.
   *
   * @param {string} mapId
   * @param {object} map
   */
  addMap: function addMap(mapId, map) {
    var _this2 = this;

    this.maps[mapId] = map;
    this.renderMapMarkers(mapId, this.doctors).then(function () {
      var options = {
        styles: [{
          textColor: 'transparent',
          url: '/sites/all/themes/alk/dist/assets/gfx/map-cluster.svg',
          height: 35,
          width: 35
        }]
      };

      // Asana Ticket: 1202552901587021.
      google.maps.event.addListener(map, "dblclick", function (e) {
        window.dataLayer.push({
          event: "fadteaser Manual Map Navigation",
          navigationInfo: {
            navigationAction: "Zoom in" // Drag Up, Drag Down, Drag Left, Drag Right, Zoom In, Zoom Out
          }
        });
      });

      google.maps.event.addListener(map, "rightclick", function (event) {
        var zoom = map.getZoom();
        setTimeout(function () {
          if (map.getZoom() != zoom) {
            // zooms are the same so they didn't double right click.
            window.dataLayer.push({
              event: "fadteaser Manual Map Navigation",
              navigationInfo: {
                navigationAction: "Zoom out" // Drag Up, Drag Down, Drag Left, Drag Right, Zoom In, Zoom Out
              }
            });
          }
        }, 300);
      });

      google.maps.event.addListener(map, 'dragstart', function () {
        window.dataLayer.push({
          event: "fadteaser Manual Map Navigation",
          navigationInfo: {
            navigationAction: "Drag" // Drag Up, Drag Down, Drag Left, Drag Right, Zoom In, Zoom Out
          }
        });
      });
      // Asana Ticket: 1202552901587021 End.

      // Add a marker clusterer to manage the markers.
      _this2.mapMarkerClusterer = new MarkerClusterer(_this2.maps[mapId], _this2.markers, options);
      if ($('.find-doctor__results-container').length) {
        $('.find-doctor__results-container').html(_this2.renderDoctorList(_this2.doctors));
      }

      // Center on the country selected in backend.
      _this2.searchMap(mapId);

      _this2.maps[mapId].addListener('idle', function () {
        _this2.mapChanged(mapId);
      });
    });
  },


  /**
   * Do a search for a location. If a location is found, set and zoom on that point on the map.
   *
   * @param {string} mapId
   * @param {string} location // location string, etc. postal code, address, country, etc.
   */
  searchMap: function searchMap(mapId, location) {
    var _this3 = this;

    if (location) {
      window.dataLayer.push({
        'event': 'trackEvent',
        'eventData': {
          'category': 'Maps',
          'action': 'Search',
          'label': 'Search term: ' + location
        }
      });
      window.dataLayer.push({
        'event': 'FAD_Search',
        'search_text': location,
        'latest_location': location
      });
    }

    if (location === undefined) {
      var bounds = new google.maps.LatLngBounds();

      for (var i = 0; i < this.markers.length; i++) {
        bounds.extend(this.markers[i].getPosition());
      }

      this.maps[mapId].fitBounds(bounds);
    } else {
      location += ', ' + this.country; // always append country to location

      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'address': location }, function (results, status) {
        if (status.toLowerCase() === 'ok') {
          var _location = results[0].geometry.location;
          var viewport = results[0].geometry.viewport;
          _this3.maps[mapId].setCenter({ lat: _location.lat(), lng: _location.lng() });
          _this3.maps[mapId].fitBounds(viewport);
        }
      });
    }
  },


  /**
   * Reset the map to its default view.
   *
   * @param {string} mapId
   */
  resetMap: function resetMap(mapId) {
    if (mapId === undefined) {
      mapId = this.mapId;
    }

    this.searchMap(mapId);
  },
  renderDoctorList: function renderDoctorList(doctors) {
    var _this4 = this;

    var telIcon = '\n      <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n          <g id="Artboard-17" transform="translate(-447.000000, -315.000000)" fill="#67C3B7" fill-rule="nonzero">\n            <g id="Icon/16/phone-black-Copy" transform="translate(446.000000, 314.000000)">\n              <path d="M14.4947743,11.0536841 L13.0021858,9.55816497 C12.6811988,9.23608834 12.2454929,9.05509785 11.7911317,9.05509785 C11.3367704,9.05509785 10.9010646,9.23608834 10.5800775,9.55816497 L10.2757161,9.86299968 C8.77566636,8.60418485 7.39005903,7.21458669 6.13518319,5.71054118 L6.43954462,5.40570647 C7.10683853,4.73541416 7.10683853,3.65073378 6.43954462,2.98044147 L4.94391255,1.48675136 C4.26562085,0.837749547 3.19766109,0.837749547 2.51936939,1.48675136 L1.70368076,2.30736642 C0.895798032,3.12233111 0.768790699,4.39285297 1.39931933,5.35205556 C3.83122532,9.02216002 6.97154589,12.1679857 10.6354713,14.6043989 C11.5959549,15.2297869 12.8612685,15.1030588 13.6790856,14.2995641 L14.4978179,13.4789491 C14.8193206,13.1576713 15,12.7214897 15,12.2666214 C15,11.8117531 14.8193206,11.3755716 14.4978179,11.0542938 L14.4947743,11.0536841 Z" id="Shape"></path>\n            </g>\n          </g>\n        </g>\n      </svg>\n    ';

    var emailIcon = '\n      <svg width="16px" height="12px" viewBox="0 0 16 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n          <g id="Artboard-17" transform="translate(-446.000000, -387.000000)" fill="#67C3B7" fill-rule="nonzero">\n            <g id="Icon/16/letter-black-Copy-3" transform="translate(446.000000, 385.000000)">\n              <path d="M7.40933333,9.704 C7.73509204,10.0288058 8.26224129,10.0288058 8.588,9.704 L15.0453333,3.24666667 C15.1347482,3.15757745 15.1661728,3.02562551 15.1265121,2.90579673 C15.0868515,2.78596796 14.9829095,2.69881932 14.858,2.68066667 C14.7946498,2.67133236 14.7307008,2.66665316 14.6666667,2.66666667 L1.33333333,2.66666667 C1.26885417,2.66658779 1.20445709,2.67126716 1.14066667,2.68066667 C1.01575717,2.69881932 0.911815181,2.78596796 0.872154538,2.90579673 C0.832493896,3.02562551 0.863918491,3.15757745 0.953333333,3.24666667 L7.40933333,9.704 Z" id="Shape"></path>\n              <path d="M15.9253333,3.888 C15.8797478,3.86864283 15.826973,3.87893391 15.792,3.914 L11.6586667,8.04733333 C11.5937478,8.1126066 11.5937478,8.21806007 11.6586667,8.28333333 L15.0206667,11.6453333 C15.1507028,11.7708096 15.2029174,11.956686 15.1572419,12.1315215 C15.1115664,12.3063569 14.975109,12.4429431 14.8003167,12.4887834 C14.6255244,12.5346237 14.4395988,12.4825844 14.314,12.3526667 L10.952,8.99066667 C10.9207319,8.95931943 10.8782758,8.94170207 10.834,8.94170207 C10.7897242,8.94170207 10.7472681,8.95931943 10.716,8.99066667 L9.29666667,10.41 C8.58078846,11.1254781 7.42054488,11.1254781 6.70466667,10.41 L5.284,8.992 C5.21872674,8.92708115 5.11327326,8.92708115 5.048,8.992 L1.686,12.354 C1.48972156,12.5433957 1.17786819,12.5405397 0.985091361,12.347581 C0.792314535,12.1546224 0.789752632,11.8427664 0.979333333,11.6466667 L4.34133333,8.28466667 C4.40625219,8.2193934 4.40625219,8.11393993 4.34133333,8.04866667 L0.208,3.91533333 C0.173211273,3.87992301 0.120210764,3.86958791 0.0746666667,3.88933333 C0.0298968041,3.90798399 0.000534185651,3.95150359 0,4 L0,12 C1.03651206e-16,12.7363797 0.596953667,13.3333333 1.33333333,13.3333333 L14.6666667,13.3333333 C15.4030463,13.3333333 16,12.7363797 16,12 L16,4 C16.0001808,3.95096306 15.9706678,3.90669343 15.9253333,3.888 Z" id="Shape"></path>\n            </g>\n          </g>\n        </g>\n      </svg>\n    ';

    var timeIcon = '\n      <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n          <g id="Artboard-19" transform="translate(-446.000000, -654.000000)" stroke="#67C3B7">\n            <g id="Icon/16/openinghours/green" transform="translate(446.000000, 654.000000)">\n              <polyline id="Path-3" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" points="8 3.5 8 8 11 8"></polyline>\n              <circle id="Oval" stroke-width="2" cx="8" cy="8" r="7"></circle>\n            </g>\n          </g>\n        </g>\n      </svg>\n    ';

    var referenceIcon = '\n      <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n          <g id="Artboard-18" transform="translate(-446.000000, -1266.000000)">\n            <g id="Group-6" transform="translate(404.000000, 759.000000)">\n              <g id="Icon/16/alert/green" transform="translate(42.000000, 507.000000)">\n                <polygon id="Triangle" stroke="#67C3B7" stroke-width="2" fill="#67C3B7" fill-rule="evenodd" stroke-linejoin="round" points="8 1 15 15 1 15"></polygon>\n                <circle id="Oval-Copy" fill="#FFFFFF" fill-rule="evenodd" cx="8" cy="13" r="1"></circle>\n                <path d="M8,6 L8,10" id="Path-3-Copy" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>\n              </g>\n            </g>\n          </g>\n        </g>\n      </svg>\n    ';

    var otherIcon = '\n      <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n          <g id="Artboard-19" transform="translate(-446.000000, -880.000000)">\n            <g id="Icon/16/info/green" transform="translate(446.000000, 880.000000)">\n              <circle id="Oval" fill="#67C3B7" fill-rule="evenodd" cx="8" cy="8" r="8"></circle>\n              <path d="M8,7 L8,12" id="Path-3-Copy-3" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>\n              <circle id="Oval" fill="#FFFFFF" fill-rule="evenodd" cx="8" cy="4" r="1"></circle>\n            </g>\n          </g>\n        </g>\n      </svg>\n    ';

    return '\n      <div class="find-doctor__results-list">\n        <ul class="find-doctor__results-items">\n          ' + doctors.map(function (doctor, i) {
      var referenceRequiredMarkup = '';

      if (doctor.reference_required !== '0') {
        referenceRequiredMarkup = '\n                <div>\n                  <div class="field-icon">\n                    ' + referenceIcon + '\n                  </div>\n\n                  <div class="field-value">\n                    <div>\n                      ' + Drupal.t('Reference required') + '\n                    </div>\n                  </div>\n                </div>\n              ';
      } else {
        referenceRequiredMarkup = '\n                <div>\n                  <div class="field-icon">\n                    ' + referenceIcon + '\n                  </div>\n\n                  <div class="field-value">\n                    <div>\n                      ' + Drupal.t('Reference not required') + '\n                    </div>\n                  </div>\n                </div>\n              ';
      }

      var doctorIntroTitleMarkup = void 0;
      if (doctor.entity_type === 'clinic') {
        doctorIntroTitleMarkup = '<p class="doctor-intro__title"><strong>' + doctor.clinic_name + '</strong><br>' + doctor.name + '</p>';
        doctorIntroTitleMarkup += '<p class="doctor-intro__specialization_areas">';
        if (doctor.specialization_allergy === '1') {
          doctorIntroTitleMarkup += Drupal.t('Allergology') + '<br>';
        }
        if (doctor.specialization_areas !== undefined && doctor.specialization_areas !== null && doctor.specialization_areas !== '') {
          doctorIntroTitleMarkup += doctor.specialization_areas + '</p>';
        }
      } else {
        doctorIntroTitleMarkup = '<p class="doctor-intro__title"><strong>' + doctor.name + '</strong>';
        if (doctor.specialization_allergy === '1') {
          doctorIntroTitleMarkup += '<br>' + Drupal.t('Allergology');
        }
        if (doctor.specialization_areas !== undefined && doctor.specialization_areas !== null && doctor.specialization_areas !== '') {
          doctorIntroTitleMarkup += '<br>' + doctor.specialization_areas;
        }
        if (doctor.clinic_name !== '') {
          doctorIntroTitleMarkup += '<br>' + doctor.clinic_name;
        }
        doctorIntroTitleMarkup += '</p>';
      }

      var doctorFax = '';
      if (doctor.fax !== undefined && doctor.fax !== null && doctor.fax !== '') {
        doctorFax = '\n                <p>\n                  <div>\n                    <b>\n                      ' + _this4.staticStrings.doctorItemLabels.faxLabel + '\n                    </b>\n                  </div>\n\n                  <a href="fax:' + doctor.fax + '">\n                    ' + doctor.fax + '\n                  </a>\n                </p>\n              ';
      }

      return '\n              <li id="listAnchor-' + doctor.id + '" class="find-doctor__result-item">\n                <div class="doctor-intro">\n                  ' + doctorIntroTitleMarkup + '\n                  <div class="doctor-intro__wrap">\n                    <p class="doctor-intro__teaser">\n                      ' + doctor.street_address + ' <br>\n                      ' + doctor.zipcode + ' ' + doctor.city + '\n                    </p>\n                  </div>\n                </div>\n\n                <div class="doctor-information" style="display: none;">\n                  ' + ((doctor.link || doctor.bookingLink || doctor.ctaLink) && (_this4.listFieldsConfig.website || _this4.listFieldsConfig.booking || _this4.listFieldsConfig.cta) ? '\n                    <div class="doctor-information__buttons">\n                      ' + (doctor.link && _this4.listFieldsConfig.website ? '<a class="button" href="' + doctor.link + '" target="_blank">' + _this4.staticStrings.doctorItemLabels.webAddressLabel + '</a>' : '') + '\n                      ' + (doctor.bookingLink && _this4.listFieldsConfig.booking ? '<a class="button" target="_blank" href="' + doctor.bookingLink + '">' + _this4.staticStrings.doctorItemLabels.bookingLabel + '</a>' : '') + '\n                      ' + (doctor.ctaLink && _this4.listFieldsConfig.cta ? '<a class="button" target="_blank" href="' + doctor.ctaLink + '">' + doctor.ctaLabel + '</a>' : '') + '\n                    </div>\n                  ' : '') + '\n\n                  ' + (_this4.listFieldsConfig.reference && doctor.hide_reference_field != '1' ? referenceRequiredMarkup : '') + '\n\n                  ' + (doctor.phone && _this4.listFieldsConfig.phone == 1 ? '\n                    <div>\n                      <div class="field-icon">\n                        ' + telIcon + '\n                      </div>\n\n                      <div class="field-value">\n                        <div>\n                          <b>\n                            ' + _this4.staticStrings.doctorItemLabels.phoneLabel + '\n                          </b>\n                        </div>\n\n                        <a class="phone" href="tel:' + doctor.phone + '">\n                          ' + doctor.phone + '\n                        </a>\n\n                        ' + doctorFax + '\n                      </div>\n                    </div>' : '') + '\n\n                  ' + (doctor.email && _this4.listFieldsConfig.email == 1 ? '\n                    <div>\n                      <div class="field-icon">\n                        ' + emailIcon + '\n                      </div>\n\n                      <div class="field-value">\n                        <div>\n                          <b>\n                            ' + _this4.staticStrings.doctorItemLabels.emailLabel + '\n                          </b>\n                        </div>\n\n                        <a href="mailto:' + doctor.email + '" class="find-doctor__emailLink">\n                          ' + doctor.email + '\n                        </a>\n                      </div>\n                    </div>' : '') + '\n\n                  ' + (doctor.openning_hours && _this4.listFieldsConfig.opening_hours ? '\n                    <div>\n                      <div class="field-icon">\n                        ' + timeIcon + '\n                      </div>\n\n                      <div class="field-value">\n                        <div>\n                          <b>\n                            ' + _this4.staticStrings.doctorItemLabels.openingHoursLabel + '\n                          </b>\n                        </div>\n\n                        ' + doctor.openning_hours + '\n                      </div>\n                    </div>' : '') + '\n\n                  ' + (_this4.otherDetails && _this4.listFieldsConfig.other_details ? '\n                    <div>\n                      <div class="field-icon">\n                        ' + otherIcon + '\n                      </div>\n\n                      <div class="field-value">\n                        ' + (_this4.otherDetails.insurance.types.length ? '\n                          <div>\n                            <b>\n                              ' + _this4.otherDetails.insurance.title + '\n                            </b>\n                          </div>\n\n                          <div>\n                          ' + (doctor.insurance_type ? Drupal.t(doctor.insurance_type.charAt(0).toUpperCase() + doctor.insurance_type.slice(1)) : 'N/A') + '\n                          </div>' : '') + '\n\n                        ' + (_this4.otherDetails.insurance.types.length && doctor.clinic_types.length && _this4.otherDetails.clinic.types.length ? '\n                          <p>&nbsp;</p>\n                        ' : '') + '\n\n                        ' + (doctor.clinic_types.length && _this4.otherDetails.clinic.types.length ? '\n                          <div>\n                            <b>\n                              ' + _this4.otherDetails.clinic.title + '\n                            </b>\n                          </div>\n\n                          <div>\n                            ' + _this4.otherDetails.clinic.types.filter(function (clinic) {
        return doctor.clinic_types.includes(clinic.id);
      }).map(function (clinic) {
        return clinic.name;
      }).join(', ') + '\n                          </div>' : '') + '\n\n                        ' + (doctor.clinic_specializations.length && _this4.otherDetails.clinic.types.length && doctor.clinic_specializations.length && _this4.otherDetails.specialization.types.length ? '\n                          <p>&nbsp;</p>\n                        ' : '') + '\n\n                        ' + (doctor.clinic_specializations.length && _this4.otherDetails.specialization.types.length ? '\n                          <div>\n                            <b>\n                              ' + _this4.otherDetails.specialization.title + '\n                            </b>\n                          </div>\n\n                          <div>\n                            ' + _this4.otherDetails.specialization.types.filter(function (specialization) {
        return doctor.clinic_specializations.includes(specialization.id);
      }).map(function (specialization) {
        return specialization.name;
      }).join(', ') + '\n                          </div>' : '') + '\n                      </div>\n                    </div>' : '') + '\n\n                  ' + (doctor.node_link ? '\n                    <div style="margin-top:28px;">\n                      <p>\n                        <a class="arrow-link read-more" href="' + doctor.node_link + '">\n                          ' + Drupal.t('Read more') + '\n                        </a>\n                      </p>\n                    </div>\n                  ' : '') + '\n                </div>\n              </li>\n            ';
    }).join('') + '\n        </ul>\n      </div>\n    ';
  },


  // TODO: Markers function here instead of inside initMap function (and just call the function inside there?
  updateMapMarkerClusterer: function updateMapMarkerClusterer(mapId) {
    var _this5 = this;

    this.renderMapMarkers(this.maps[mapId], this.doctorsVisible).then(function () {
      _this5.mapMarkerClusterer.clearMarkers();
      _this5.mapMarkerClusterer.addMarkers(_this5.markers);
      google.maps.event.trigger(_this5.maps[mapId], 'resize');

      _this5.mapChanged(mapId);
    });
  },
  renderMapMarkers: function renderMapMarkers(mapId, doctorArray) {
    // Add some markers to the map.
    // Note: The code uses the JavaScript Array.prototype.map() method to
    // create an array of markers based on a given "locations" array.
    // The map() method here has nothing to do with the Google Maps API.
    this.markers = doctorArray.map(function (doctor) {
      // Add marker icon
      var markerIcon = {
        url: '/sites/all/themes/alk/dist/assets/gfx/map-location.svg',
        scaledSize: new google.maps.Size(40, 40)
      };

      // Add anchor link
      var anchorLink = '#listAnchor-' + doctor.id;
      var marker = new google.maps.Marker({
        position: {
          lat: parseFloat(doctor.latitude),
          lng: parseFloat(doctor.longitude)
        },
        id: doctor.id,
        url: anchorLink,
        optimized: false,
        icon: markerIcon
      });

      marker['infoWindow'] = new google.maps.InfoWindow({ content: buildInfoWindowContent(doctor) });
      marker.setPosition({ lat: parseFloat(doctor.latitude), lng: parseFloat(doctor.longitude) });
      google.maps.event.addListener(marker, 'click', function () {
        window.dataLayer.push({
          event: 'trackEvent',
          eventData: {
            category: 'Maps',
            action: 'Click - Red Pin',
            label: doctor.name
          }
        });

        window.dataLayer.push({
          event: 'FAD_PinClick',
          doctorInfo: {
            doctorName: doctor.name,
            doctorCity: doctor.city,
            latest_location: doctor.city
          }
        });

        // Scroll anchor list item into view and open
        if ($('.find-doctor__results-container').length) {
          var $current = $(marker.url);
          var $active = $('.find-doctor__result-item.is-active');
          var offset = void 0;

          if ($current.hasClass('is-active')) {
            $current.removeClass('is-active').find('.doctor-information').slideUp();
          } else {
            // collapse all expanded items if any
            if ($active.length) {
              $active.removeClass('is-active').find('.doctor-information').slideUp(function () {
                offset = $current.position().top;

                $current.addClass('is-active').find('.doctor-information').slideDown(function () {
                  $('.find-doctor__results-container').animate({ scrollTop: offset });
                });
              });
            } else {
              offset = $current.position().top;

              $current.addClass('is-active').find('.doctor-information').slideDown(function () {
                $('.find-doctor__results-container').animate({ scrollTop: offset });
              });
            }
          }
        }

        // close all infowindows
        for (var i = 0; i < window.findDoctor.markers.length; i++) {
          var currentMarker = window.findDoctor.markers[i];
          currentMarker['infoWindow'].close();
        }

        // open current markers infowindow
        this['infoWindow'].open(window.findDoctor.map, this);

        if ($('.gm-style-iw').length > 0) {
          window.findDoctor.styleInfowindow();
        } else {
          setTimeout(function () {
            window.findDoctor.styleInfowindow();
          }, 50);
        }
      });

      return marker;
    });

    return new _promise2.default(function (resolve, reject) {
      resolve();
    });
  },
  styleInfowindow: function styleInfowindow() {
    // Reference to the DIV which receives the contents of the infowindow using jQuery
    var iwOuter = $('.gm-style-iw');

    // Set max-height on info window inner div to activate scroll on large infowindows
    iwOuter.first().children(':first-child').addClass('iw-inner');

    /* The DIV we want to change is above the .gm-style-iw DIV.
     * So, we use jQuery and create a iwBackground variable,
     * and took advantage of the existing reference to .gm-style-iw for the previous DIV with .prev().
     */
    iwOuter.parent().addClass('iw__parent');

    var iwBackground = iwOuter.prev();
    // Removes background shadow DIV
    iwBackground.children(':nth-child(2)').css({ 'display': 'none' });
    // Removes arrow background
    iwBackground.children(':nth-child(3)').css({ 'display': 'none' });
    // Removes white background DIV
    iwBackground.children(':nth-child(4)').css({ 'display': 'none' });
    // Add class to customize arrow
    iwBackground.children(':first-child').addClass('iw-marker-arrow');

    // Reference to the div that groups the close button elements.
    var iwCloseBtn = iwOuter.next();
    // Apply the desired effect to the close button
    iwCloseBtn.css({ opacity: '1', right: '10px', top: '25px' });

    if ($('.iw-inner').height() < 200) {
      $('.iw-bottom-gradient').css({ display: 'none' });
    }
  },
  insuranceFilterSelect: function insuranceFilterSelect() {
    if (typeof this.insuranceTypes.types == 'undefined' || typeof this.insuranceTypes.types == 'null' || !this.insuranceTypes.types.length) {
      return;
    }

    return '\n      <div class="find-doctor__insurance">\n        <p class="teaser">\n          ' + this.insuranceTypes.title + '\n        </p>\n\n        <select class="filter-options--insurance">\n          ' + this.insuranceTypes.types.map(function (type) {
      return '\n              <option value=' + type.id + '>' + type.name + '</option>\n            ';
    }).join('') + '\n        </select>\n      </div>\n    ';
  },
  clinicTypeCheckboxFilter: function clinicTypeCheckboxFilter() {
    if (typeof this.clinicTypes.types == 'undefined' || typeof this.clinicTypes.types == 'null' || !this.clinicTypes.types.length) {
      return;
    }

    return '\n      <div class="find-doctor__clinic-type">\n        <p class="teaser">' + this.clinicTypes.title + '</p>\n        <div class="filter-options--clinic-type">\n        ' + this.clinicTypes.types.map(function (type) {
      return '\n            <div class="form-checkbox">\n              <input class="clinic-type" type="checkbox" id="clinic-type_' + type.id + '" name="clinic-type" value="' + type.id + '" />\n              <label for="clinic-type_' + type.id + '">' + type.name + '</label>\n            </div>\n          ';
    }).join('') + '\n        </div>\n      </div>\n    ';
  },
  specializationCheckboxFilter: function specializationCheckboxFilter() {
    if (typeof this.specializationTypes.types == 'undefined' || typeof this.specializationTypes.types == 'null' || !this.specializationTypes.types.length) {
      return;
    }

    return '\n      <div class="find-doctor__specialization">\n        <p class="teaser">' + this.specializationTypes.title + '</p>\n        <div class="filter-options--specialization">\n          ' + this.specializationTypes.types.map(function (type) {
      return '\n              <div class="form-checkbox">\n                <input class="specialization" type="checkbox" id="specialization_' + type.id + '" name="specialization" value="' + type.id + '" />\n                <label for="specialization_' + type.id + '">' + type.name + '</label>\n              </div>\n            ';
    }).join('') + '\n        </div>\n      </div>\n    ';
  },
  filterChanged: function filterChanged(mapId) {
    var _this6 = this;

    this.doctorsVisible = this.doctors.filter(function (elm) {
      if (elm.visible === false) {
        return false;
      }

      var insurance = _this6.filter.insurance === undefined || _this6.filter.insurance === null || _this6.filter.insurance === elm.insurance_type || _this6.filter.insurance === 'all';
      var clinics = false;

      if (_this6.filter.clinics !== undefined && _this6.filter.clinics !== null && _this6.filter.clinics.length > 0) {
        elm.clinic_types.map(function (item) {
          if (_this6.filter.clinics.includes(item)) {
            clinics = true;
          }
        });
      } else {
        clinics = true;
      }

      var specializations = false;
      if (_this6.filter.specializations !== undefined && _this6.filter.specializations !== null && _this6.filter.specializations.length > 0) {
        elm.clinic_specializations.map(function (item) {
          if (_this6.filter.specializations.includes(item)) {
            specializations = true;
          }
        });
      } else {
        specializations = true;
      }

      return insurance && clinics && specializations;
    });

    // TODO: Add changes to map (markers) as well in initMap const markers (add a function above? – see other TODO)
    this.updateMapMarkerClusterer(mapId);
  },
  mapChanged: function mapChanged(mapId) {
    var _this7 = this;

    var markersVisible = [];
    var bounds = this.maps[mapId].getBounds();
    var zoom = this.maps[mapId].getZoom();
    var lat = this.maps[mapId].center.lat();
    var lng = this.maps[mapId].center.lng();

    this.doctors.sort(function (a, b) {
      var diffA = a.score / (1 + _this7.geolocationDistance(a.latitude, a.longitude, lng, lat) / 1000);
      var diffB = b.score / (1 + _this7.geolocationDistance(b.latitude, b.longitude, lng, lat) / 1000);

      if (diffA < diffB) {
        return 1;
      } else if (diffA > diffB) {
        return -1;
      } else {
        return 0; // same
      }
    });
    $('.find-doctor__results-container').empty();
    if ($('.find-doctor__results-container').length) {
      $('.find-doctor__results-container').html(this.renderDoctorList(this.doctors));
    }

    if (bounds !== null && this.markers.length > 0) {
      for (var i = 0; i < this.markers.length; i++) {
        if (bounds.contains(this.markers[i].getPosition())) {
          // map contains marker
          markersVisible.push(this.markers[i].id);
        }
      }

      // zoom out until at least a marker is visible
      if (markersVisible.length < 1) {
        zoom--;
        this.maps[mapId].setOptions({ zoom: zoom });
      }

      if ($('.find-doctor__results-container').length) {
        for (var _i = 0; _i < this.doctors.length; _i++) {
          if (markersVisible.includes(this.doctors[_i].id)) {
            $('.find-doctor__results-list #listAnchor-' + this.doctors[_i].id).removeClass('hidden');
          } else {
            $('.find-doctor__results-list #listAnchor-' + this.doctors[_i].id).addClass('hidden');
          }
        }

        if ($('.find-doctor__results-list .find-doctor__result-item').not('.hidden').length) {
          $('.find-doctor__results-list--no-result').remove();
        } else if (!$('.find-doctor__results-list--no-result').length) {
          $('.find-doctor__results-items').append('<div class="find-doctor__results-list--no-result">' + this.staticStrings.noDoctorsRichText + '</div>');
        }
      }
    }
  },

  /**
  * Calc distance between geolocation.
  *
  * @param {number} latitudeFrom
  * @param {number} longitudeFrom
  * @param {number} latitudeTo
  * @param {number} longitudeTo
  * @return {number}
  */

  geolocationDistance: function geolocationDistance(latitudeFrom, longitudeFrom, longitudeTo, latitudeTo) {
    // convert from degrees to radians
    var latFrom = this.deg2rad(latitudeFrom);
    var lonFrom = this.deg2rad(longitudeFrom);
    var latTo = this.deg2rad(latitudeTo);
    var lonTo = this.deg2rad(longitudeTo);

    var latDelta = latTo - latFrom;
    var lonDelta = lonTo - lonFrom;

    var angle = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(latDelta / 2), 2) + Math.cos(latFrom) * Math.cos(latTo) * Math.pow(Math.sin(lonDelta / 2), 2)));
    return angle;
  },
  deg2rad: function deg2rad(degrees) {
    var pi = Math.PI;
    return degrees * (pi / 180);
  }
};

/**
 * Build HTML for the info window for a doctor.
 *
 * @param {object} doctor
 * @return {string}
 */
var buildInfoWindowContent = function buildInfoWindowContent(doctor) {
  var linkMarkup = doctor.node_link ? '<a href="' + doctor.node_link + '" doctor-name="' + doctor.name + '" data-city="' + doctor.city + '" class="iw__doctor-link read-more"">' + window.findDoctor.staticStrings.doctorItemLabels.readMoreLabel + '</a>' : '';

  var doctorIntroTitleMarkup = void 0;
  if (doctor.entity_type === 'clinic') {
    doctorIntroTitleMarkup = '<p class="iw__doctor-name"><strong>' + doctor.clinic_name + '</strong><br>' + doctor.name + '</p>';
  } else {
    doctorIntroTitleMarkup = '<p class="iw__doctor-name"><strong>' + doctor.name + '</strong>';
    doctorIntroTitleMarkup += doctor.clinic_name !== '' ? '<br>' + doctor.clinic_name : '';
    doctorIntroTitleMarkup += '</p>';
  }

  return '\n    <div class="iw__container">\n      <div class="iw__doctor-content">\n        ' + doctorIntroTitleMarkup + '\n        ' + doctor.street_address + '</br>\n        ' + doctor.zipcode + ' ' + doctor.city + '\n        ' + linkMarkup + '\n      </div>\n    </div>\n\n    <div class="iw-bottom-gradient"></div>\n  ';
};

window.initMap = function () {
  var mapContainers = document.getElementsByName('googleMap');

  Array.prototype.forEach.call(mapContainers, function (map) {
    var mapId = map.getAttribute('id');
    var googleMap = new google.maps.Map(map, {
      gestureHandling: 'cooperative',
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      zoom: 20,
      minZoom: 3,
      maxZoom: 18
    });

    var options = {
      componentRestrictions: { country: window.country_code },
      fields: ["address_components", "geometry", "icon", "name"],
      strictBounds: false
    };

    var input = document.getElementById(mapId + "-input");

    var searchBox = new google.maps.places.Autocomplete(input, options);

    searchBox.addListener("place_changed", function () {
      window.findDoctor.searchMap(mapId, input.value);
    });

    window.findDoctor.mapId = mapId;
    window.findDoctor.addMap(mapId, googleMap);
    if (window.findDoctor.enableGeoLookup) {
      // storing data as local storage insted of cookies.
      // let savedCountry = getCookie('fadCountry=');
      // let savedCity = getCookie('fadCity=');
      var savedCountry = localStorage.getItem("fadCountry");
      var savedCity = localStorage.getItem("fadCity");
      if (savedCountry !== undefined && savedCountry !== null && savedCity !== undefined && savedCity !== null) {
        countryMap(savedCountry, savedCity);
      } else {
        // Look up location from IP
        // fetch('https://extreme-ip-lookup.com/json/')
        window.fetch('https://api.ipstack.com/check?access_key=771c7cd15b294eb19b2e29264ff2b8c2').then(function (response) {
          return response.ok ? response.json() : undefined;
        }).then(function (response) {
          if (response) {
            countryMap(response.country_name, response.city);
            // Asana task: 1205223153870117.
            // document.cookie = `fadCountry=` + response.country_name + `; max-age=3600;`
            // document.cookie = `fadCity=` + response.city + `; max-age=3600;`
            localStorage.setItem("fadCountry", response.country_name);
            localStorage.setItem("fadCity", response.city);
          }
        });
      }
    }
  });
};

function countryMap(country, city) {
  var countryMap = {
    DE: 'Germany',
    DK: 'Denmark',
    FI: 'Finland',
    FR: 'France',
    IT: 'Italy',
    US: 'United States',
    NL: 'Netherlands',
    NO: 'Norway'
  };
  if (countryMap[window.country_code] === country) {
    window.findDoctor.searchMap(window.findDoctor.mapId, city);
  }
}

function getCookie(name) {
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookies = decodedCookie.split(';');
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.indexOf(name) == 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
}

(function ($) {
  $(function () {

    $('[name="map-search-submit"]').on('click', function () {
      var mapId = $(this).data('map-id');
      var searchValue = $('[name="map-search"][data-map-id="' + mapId + '"]').val();

      if (searchValue) {
        window.findDoctor.searchMap(mapId, searchValue);
      } else {
        window.findDoctor.searchMap(mapId);
      }
    });
    $('.find-doctor__filter-trigger').on('click', function () {
      $('.find-doctor__filter-options').toggleClass('hide');
      $('.find-doctor__filter-trigger').toggleClass('active');
    });
    $('.filter-options__reset-btn').on('click', function () {
      window.location.reload(); // city hack for resetting the form (by reloading the page)
    });

    $('[name="map-search"]').on('keypress', function (e) {
      if (e.which === 13) {
        $('[name="map-search-submit"]').trigger('click');
      }
    });
    $(document).on('click', '.find-doctor__results-list .find-doctor__results-items .doctor-information .phone', function (event) {
      window.datalayer.push({
        event: "Phone clinic",
        eventData: {
          category: 'FaD',
          action: 'Click - Phone',
          label: event.target.innerText
        }
      });
    });
    $(document).on('click', '.find-doctor__results-list .find-doctor__results-items .doctor-information .doctor-information__buttons a', function (event) {
      window.datalayer.push({
        event: "Website clinic",
        eventData: {
          category: 'FaD',
          action: 'Click - Website',
          label: event.target.getAttribute('href')
        }
      });
    });
    $(document).on('click', '.find-doctor__results-list .find-doctor__results-items .doctor-information .read-more', function (event) {
      var $current = $(event.currentTarget).closest('.find-doctor__result-item');
      window.dataLayer.push({
        event: 'trackEvent',
        eventData: {
          category: 'Maps',
          action: 'Click - Read More - Below Map',
          label: $current.find('.doctor-intro__title').text()
        }
      });
    });
    $(document).on('click', '.iw__doctor-content .iw__doctor-link', function (event) {
      var $current = $(event.currentTarget).closest('.iw__doctor-content');
      window.dataLayer.push({
        event: 'trackEvent',
        eventData: {
          category: 'Maps',
          action: 'Click - Read More - In Map',
          label: $current.find('.iw__doctor-name').text()
        }
      });
    });
    $(document).on('click', '.find-doctor__results-list .find-doctor__result-item .doctor-intro', function (event) {
      var $current = $(event.currentTarget).closest('.find-doctor__result-item');
      var $active = $('.find-doctor__result-item.is-active');
      var offset = void 0;

      window.dataLayer.push({
        event: 'trackEvent',
        eventData: {
          category: 'Maps',
          action: 'Click - List expand',
          label: $current.find('.doctor-intro__title').text()
        }
      });

      if ($current.hasClass('is-active')) {
        $current.removeClass('is-active').find('.doctor-information').slideUp();
      } else {
        // collapse all expanded items if any
        var clinicId = $current.attr('id').replace('listAnchor-', '');
        var clinic = doctors.find(function (el) {
          return el.id == clinicId;
        });

        window.dataLayer.push({
          ClinicInfo: {
            ClinicName: clinic.clinic_name || clinic.name || null,
            ClinicPhone: clinic.phone || null,
            ClinicWebsite: clinic.link || null,
            ClinicEmail: clinic.email || null
          }
        });

        if ($active.length) {
          $active.removeClass('is-active').find('.doctor-information').slideUp(function () {
            offset = $current.position().top;

            $current.addClass('is-active').find('.doctor-information').slideDown(function () {
              $('.find-doctor__results-container').animate({ scrollTop: offset });
            });
          });
        } else {
          offset = $current.position().top;

          $current.addClass('is-active').find('.doctor-information').slideDown(function () {
            $('.find-doctor__results-container').animate({ scrollTop: offset });
          });
        }
      }
    });

    $(document).on('click', '.find-doctor__emailLink', function () {
      window.dataLayer.push({
        event: 'Email clinic'
      });
    });

    // Asana Ticket: 1202552901587021.
    $(document).one("mouseover", "#map-input", function (event) {
      window.dataLayer.push({
        event: "fadteaser Manual Map Navigation",
        hoverElement: {
          hoverElement: "Search"
        }
      });
    });

    $(document).one("mouseover", "#map.find-doctor__map", function (event) {
      window.dataLayer.push({
        event: "fadteaser Manual Map Navigation",
        hoverElement: {
          hoverElement: "Map"
        }
      });
    });

    $(document).on('click', '[title="Zoom out"]', function (event) {
      window.dataLayer.push({
        event: "fadteaser Manual Map Navigation",
        navigationInfo: {
          navigationAction: "Zoom out" // Drag Up, Drag Down, Drag Left, Drag Right, Zoom In, Zoom Out
        }
      });
      window.dataLayer.push({
        event: "FAD_MapInteraction",
        interaction_type: "ZoomOut"
      });
    });

    $(document).on('click', '[title="Zoom in"]', function (event) {
      window.dataLayer.push({
        event: "fadteaser Manual Map Navigation",
        navigationInfo: {
          navigationAction: "Zoom in" // Drag Up, Drag Down, Drag Left, Drag Right, Zoom In, Zoom Out
        }
      });
      window.dataLayer.push({
        event: "FAD_MapInteraction",
        interaction_type: "ZoomIn"
      });
    });
    // Asana Ticket: 1202552901587021 End.

    $(document).on('change', '.filter-options--insurance', function (event) {
      var val = $(event.target).val();
      var mapId = 'map_list'; // TODO: find dynamically

      window.findDoctor.filter.insurance = val;
      window.findDoctor.filterChanged(mapId);
    });

    $(document).on('change', '.filter-options--clinic-type .clinic-type', function (event) {
      var el = $(event.target);
      var checked = el.prop('checked');
      var val = el.val();
      var mapId = 'map_list'; // TODO: find dynamically

      if (checked) {
        window.findDoctor.filter.clinics.push(val);
      } else {
        var idx = window.findDoctor.filter.clinics.indexOf(val);

        if (idx > -1) {
          window.findDoctor.filter.clinics.splice(idx, 1);
        }
      }

      window.findDoctor.filterChanged(mapId);
    });

    $(document).on('change', '.find-doctor__specialization .specialization', function (event) {
      var el = $(event.target);
      var checked = el.prop('checked');
      var val = el.val();
      var mapId = 'map_list'; // TODO: find dynamically

      if (checked) {
        window.findDoctor.filter.specializations.push(val);
      } else {
        var idx = window.findDoctor.filter.specializations.indexOf(val);

        if (idx > -1) {
          window.findDoctor.filter.specializations.splice(idx, 1);
        }
      }

      window.findDoctor.filterChanged(mapId);
    });

    $(document).on('click', '.find-doctor__collapse', function (event) {
      var $block = $(event.target).closest('.block-find-doctor-list');

      $block.toggleClass('expand-filters');
    });

    var filterOptionsElement = $('.find-doctor__filter-options');

    if (filterOptionsElement.length) {
      filterOptionsElement.prepend(window.findDoctor.insuranceFilterSelect(), window.findDoctor.clinicTypeCheckboxFilter(), window.findDoctor.specializationCheckboxFilter());
    }
  });
})(window.jQuery);

},{"babel-runtime/core-js/promise":5}],107:[function(require,module,exports){
'use strict';

var $ = window.jQuery;
if (!String.prototype.includes) {
  String.prototype.includes = function () {
    'use strict';

    return String.prototype.indexOf.apply(this, arguments) !== -1;
  };
}
$(function () {
  var mdown;
  var $cell = $('.footer__content .cell');

  // if ($('.read-time').length) {
  //   var wordsPerMinute = 250
  //   var wordsPerPage = $('.pz-main').find('.block-article-text, .block-article-image, .block-content, .block-image-teaser, .block-videopanel').text().split(' ').length
  //   var readMinutes = Math.floor(wordsPerPage / wordsPerMinute)

  //   if ($('.block-self-test').length) {
  //     readMinutes += 2
  //   }

  //   $('.read-time').show()
  //   $('.read-time #readMinutes').text(readMinutes)
  // }

  var $disclaimer = $('.form--disclaimer');
  if ($disclaimer.length) {
    $('.form-textarea').closest('.js-form-item').after($disclaimer);
    $disclaimer.removeClass('contact-message-feedback-form hidden');
  }

  var $clone = $('.popup-container');
  $clone.clone().prependTo('body');
  $clone.remove();

  $('.popup-container').on('mousedown', function (e) {
    mdown = e.target;
  }).on('mouseup', function (e) {
    if (e.target === this && mdown === this) {
      var close = $(this).data('close');
      if (close) eval(close);else $(this).hide();
    }
  });

  document.body.className += " page-loaded";
  // Create the event
  var event = new CustomEvent("page-loaded");

  // Dispatch/Trigger/Fire the event
  document.dispatchEvent(event);
});

},{}],108:[function(require,module,exports){
'use strict';

var $ = window.jQuery;

$(function () {
  /**
   * Make sure the menu items always stay in one line
   * @return null
   */
  function wrapMenuText() {
    var container = $('.header__frame');
    var navigation = $('.nav--first');

    while (container.height() < navigation.height()) {
      // reduce the font-size with 1px at a time
      navigation.css({ fontSize: '-=1' });
    }
  }

  wrapMenuText();
});

},{}],109:[function(require,module,exports){
'use strict';

var $ = window.jQuery;

$(function () {
  // On init, check if the query has a hash, and adjust the scrolling to take the header into account.
  if (window.location.hash) {
    window.setTimeout(function () {
      var $element = $(window.location.hash.split('?')[0]);

      var headerHeight = $(window).width() < 1100 ? $('.on-canvas-nav').height() + 30 : $('.header__container').height() + 60;
      var elementOffset = $element.length ? $element.offset().top : $(window).scrollTop();

      $(window).scrollTop(elementOffset - headerHeight);
    }, 250);
  }

  // On click of link, check if it's a bookmark and adjust the scrolling to take the header into account.
  $('body').on('click', 'a', function (e) {
    if ($(this).is('[href^="#"]')) {
      e.preventDefault();

      var value = $(this).attr('href');
      var $element = $(value);
      var headerHeight = $(window).width() < 1100 ? $('.on-canvas-nav').height() + 30 : $('.header__container').height() + 60;
      var elementOffset = $element.length ? $element.offset().top : $(window).scrollTop();

      $(window).scrollTop(elementOffset - headerHeight);
    }
  });
});

},{}],110:[function(require,module,exports){
"use strict";

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * pagination.js 2.1.5
 * A jQuery plugin to provide simple yet fully customisable pagination
 * https://github.com/superRaytin/paginationjs

 * Homepage: http://pagination.js.org
 *
 * Copyright 2014-2100, superRaytin
 * Released under the MIT license.
*/
!function (a, b) {
  function c(a) {
    throw new Error("Pagination: " + a);
  }function d(a) {
    a.dataSource || c('"dataSource" is required.'), "string" == typeof a.dataSource ? void 0 === a.totalNumberLocator ? void 0 === a.totalNumber ? c('"totalNumber" is required.') : b.isNumeric(a.totalNumber) || c('"totalNumber" is incorrect. (Number)') : b.isFunction(a.totalNumberLocator) || c('"totalNumberLocator" should be a Function.') : i.isObject(a.dataSource) && (void 0 === a.locator ? c('"dataSource" is an Object, please specify "locator".') : "string" == typeof a.locator || b.isFunction(a.locator) || c(a.locator + " is incorrect. (String | Function)")), void 0 === a.formatResult || b.isFunction(a.formatResult) || c('"formatResult" should be a Function.');
  }function e(a) {
    var c = ["go", "previous", "next", "disable", "enable", "refresh", "show", "hide", "destroy"];b.each(c, function (b, c) {
      a.off(h + c);
    }), a.data("pagination", {}), b(".paginationjs", a).remove();
  }function f(a, b) {
    return ("object" == (b = typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a)) ? null == a && "null" || Object.prototype.toString.call(a).slice(8, -1) : b).toLowerCase();
  }void 0 === b && c("Pagination requires jQuery.");var g = "pagination",
      h = "__pagination-";b.fn.pagination && (g = "pagination2"), b.fn[g] = function (f) {
    if (void 0 === f) return this;var j = b(this),
        k = b.extend({}, b.fn[g].defaults, f),
        l = { initialize: function initialize() {
        var a = this;if (j.data("pagination") || j.data("pagination", {}), !1 !== a.callHook("beforeInit")) {
          j.data("pagination").initialized && b(".paginationjs", j).remove(), a.disabled = !!k.disabled;var c = a.model = { pageRange: k.pageRange, pageSize: k.pageSize };a.parseDataSource(k.dataSource, function (b) {
            a.isAsync = i.isString(b), i.isArray(b) && (c.totalNumber = k.totalNumber = b.length), a.isDynamicTotalNumber = a.isAsync && k.totalNumberLocator;var d = a.render(!0);k.className && d.addClass(k.className), c.el = d, j["bottom" === k.position ? "append" : "prepend"](d), a.observer(), j.data("pagination").initialized = !0, a.callHook("afterInit", d);
          });
        }
      }, render: function render(a) {
        var c = this,
            d = c.model,
            e = d.el || b('<div class="paginationjs"></div>'),
            f = !0 !== a;c.callHook("beforeRender", f);var g = d.pageNumber || k.pageNumber,
            h = k.pageRange || 0,
            i = c.getTotalPage(),
            j = g - h,
            l = g + h;return l > i && (l = i, j = i - 2 * h, j = j < 1 ? 1 : j), j <= 1 && (j = 1, l = Math.min(2 * h + 1, i)), e.html(c.generateHTML({ currentPage: g, pageRange: h, rangeStart: j, rangeEnd: l })), k.hideWhenLessThanOnePage && e[i <= 1 ? "hide" : "show"](), c.callHook("afterRender", f), e;
      }, generatePageNumbersHTML: function generatePageNumbersHTML(a) {
        var b,
            c = this,
            d = a.currentPage,
            e = c.getTotalPage(),
            f = a.rangeStart,
            g = a.rangeEnd,
            h = "",
            i = k.pageLink,
            j = k.ellipsisText,
            l = k.classPrefix,
            m = k.activeClassName,
            n = k.disableClassName;if (null === k.pageRange) {
          for (b = 1; b <= e; b++) {
            h += b == d ? '<li class="' + l + "-page J-paginationjs-page " + m + '" data-num="' + b + '"><a>' + b + "</a></li>" : '<li class="' + l + '-page J-paginationjs-page" data-num="' + b + '"><a href="' + i + '">' + b + "</a></li>";
          }return h;
        }if (f <= 3) for (b = 1; b < f; b++) {
          h += b == d ? '<li class="' + l + "-page J-paginationjs-page " + m + '" data-num="' + b + '"><a>' + b + "</a></li>" : '<li class="' + l + '-page J-paginationjs-page" data-num="' + b + '"><a href="' + i + '">' + b + "</a></li>";
        } else k.showFirstOnEllipsisShow && (h += '<li class="' + l + "-page " + l + '-first J-paginationjs-page" data-num="1"><a href="' + i + '">1</a></li>'), h += '<li class="' + l + "-ellipsis " + n + '"><a>' + j + "</a></li>";for (b = f; b <= g; b++) {
          h += b == d ? '<li class="' + l + "-page J-paginationjs-page " + m + '" data-num="' + b + '"><a>' + b + "</a></li>" : '<li class="' + l + '-page J-paginationjs-page" data-num="' + b + '"><a href="' + i + '">' + b + "</a></li>";
        }if (g >= e - 2) for (b = g + 1; b <= e; b++) {
          h += '<li class="' + l + '-page J-paginationjs-page" data-num="' + b + '"><a href="' + i + '">' + b + "</a></li>";
        } else h += '<li class="' + l + "-ellipsis " + n + '"><a>' + j + "</a></li>", k.showLastOnEllipsisShow && (h += '<li class="' + l + "-page " + l + '-last J-paginationjs-page" data-num="' + e + '"><a href="' + i + '">' + e + "</a></li>");return h;
      }, generateHTML: function generateHTML(a) {
        var c,
            d = this,
            e = a.currentPage,
            f = d.getTotalPage(),
            g = d.getTotalNumber(),
            h = k.showPrevious,
            i = k.showNext,
            j = k.showPageNumbers,
            l = k.showNavigator,
            m = k.showGoInput,
            n = k.showGoButton,
            o = k.pageLink,
            p = k.prevText,
            q = k.nextText,
            r = k.goButtonText,
            s = k.classPrefix,
            t = k.disableClassName,
            u = k.ulClassName,
            v = "",
            w = '<input type="text" class="J-paginationjs-go-pagenumber">',
            x = '<input type="button" class="J-paginationjs-go-button" value="' + r + '">',
            y = b.isFunction(k.formatNavigator) ? k.formatNavigator(e, f, g) : k.formatNavigator,
            z = b.isFunction(k.formatGoInput) ? k.formatGoInput(w, e, f, g) : k.formatGoInput,
            A = b.isFunction(k.formatGoButton) ? k.formatGoButton(x, e, f, g) : k.formatGoButton,
            B = b.isFunction(k.autoHidePrevious) ? k.autoHidePrevious() : k.autoHidePrevious,
            C = b.isFunction(k.autoHideNext) ? k.autoHideNext() : k.autoHideNext,
            D = b.isFunction(k.header) ? k.header(e, f, g) : k.header,
            E = b.isFunction(k.footer) ? k.footer(e, f, g) : k.footer;return D && (c = d.replaceVariables(D, { currentPage: e, totalPage: f, totalNumber: g }), v += c), (h || j || i) && (v += '<div class="paginationjs-pages">', v += u ? '<ul class="' + u + '">' : "<ul>", h && (e <= 1 ? B || (v += '<li class="' + s + "-prev " + t + '"><a>' + p + "</a></li>") : v += '<li class="' + s + '-prev J-paginationjs-previous" data-num="' + (e - 1) + '" title="Previous page"><a href="' + o + '">' + p + "</a></li>"), j && (v += d.generatePageNumbersHTML(a)), i && (e >= f ? C || (v += '<li class="' + s + "-next " + t + '"><a>' + q + "</a></li>") : v += '<li class="' + s + '-next J-paginationjs-next" data-num="' + (e + 1) + '" title="Next page"><a href="' + o + '">' + q + "</a></li>"), v += "</ul></div>"), l && y && (c = d.replaceVariables(y, { currentPage: e, totalPage: f, totalNumber: g }), v += '<div class="' + s + '-nav J-paginationjs-nav">' + c + "</div>"), m && z && (c = d.replaceVariables(z, { currentPage: e, totalPage: f, totalNumber: g, input: w }), v += '<div class="' + s + '-go-input">' + c + "</div>"), n && A && (c = d.replaceVariables(A, { currentPage: e, totalPage: f, totalNumber: g, button: x }), v += '<div class="' + s + '-go-button">' + c + "</div>"), E && (c = d.replaceVariables(E, { currentPage: e, totalPage: f, totalNumber: g }), v += c), v;
      }, findTotalNumberFromRemoteResponse: function findTotalNumberFromRemoteResponse(a) {
        this.model.totalNumber = k.totalNumberLocator(a);
      }, go: function go(a, c) {
        function d(a) {
          if (!1 === e.callHook("beforePaging", g)) return !1;if (f.direction = void 0 === f.pageNumber ? 0 : g > f.pageNumber ? 1 : -1, f.pageNumber = g, e.render(), e.disabled && e.isAsync && e.enable(), j.data("pagination").model = f, k.formatResult) {
            var d = b.extend(!0, [], a);i.isArray(a = k.formatResult(d)) || (a = d);
          }j.data("pagination").currentPageData = a, e.doCallback(a, c), e.callHook("afterPaging", g), 1 == g && e.callHook("afterIsFirstPage"), g == e.getTotalPage() && e.callHook("afterIsLastPage");
        }var e = this,
            f = e.model;if (!e.disabled) {
          var g = a;if ((g = parseInt(g)) && !(g < 1)) {
            var h = k.pageSize,
                l = e.getTotalNumber(),
                m = e.getTotalPage();if (!(l > 0 && g > m)) {
              if (!e.isAsync) return void d(e.getDataFragment(g));var n = {},
                  o = k.alias || {};n[o.pageSize ? o.pageSize : "pageSize"] = h, n[o.pageNumber ? o.pageNumber : "pageNumber"] = g;var p = b.isFunction(k.ajax) ? k.ajax() : k.ajax,
                  q = { type: "get", cache: !1, data: {}, contentType: "application/x-www-form-urlencoded; charset=UTF-8", dataType: "json", async: !0 };b.extend(!0, q, p), b.extend(q.data, n), q.url = k.dataSource, q.success = function (a) {
                e.isDynamicTotalNumber ? e.findTotalNumberFromRemoteResponse(a) : e.model.totalNumber = k.totalNumber, d(e.filterDataByLocator(a));
              }, q.error = function (a, b, c) {
                k.formatAjaxError && k.formatAjaxError(a, b, c), e.enable();
              }, e.disable(), b.ajax(q);
            }
          }
        }
      }, doCallback: function doCallback(a, c) {
        var d = this,
            e = d.model;b.isFunction(c) ? c(a, e) : b.isFunction(k.callback) && k.callback(a, e);
      }, destroy: function destroy() {
        !1 !== this.callHook("beforeDestroy") && (this.model.el.remove(), j.off(), b("#paginationjs-style").remove(), this.callHook("afterDestroy"));
      }, previous: function previous(a) {
        this.go(this.model.pageNumber - 1, a);
      }, next: function next(a) {
        this.go(this.model.pageNumber + 1, a);
      }, disable: function disable() {
        var a = this,
            b = a.isAsync ? "async" : "sync";!1 !== a.callHook("beforeDisable", b) && (a.disabled = !0, a.model.disabled = !0, a.callHook("afterDisable", b));
      }, enable: function enable() {
        var a = this,
            b = a.isAsync ? "async" : "sync";!1 !== a.callHook("beforeEnable", b) && (a.disabled = !1, a.model.disabled = !1, a.callHook("afterEnable", b));
      }, refresh: function refresh(a) {
        this.go(this.model.pageNumber, a);
      }, show: function show() {
        var a = this;a.model.el.is(":visible") || a.model.el.show();
      }, hide: function hide() {
        var a = this;a.model.el.is(":visible") && a.model.el.hide();
      }, replaceVariables: function replaceVariables(a, b) {
        var c;for (var d in b) {
          var e = b[d],
              f = new RegExp("<%=\\s*" + d + "\\s*%>", "img");c = (c || a).replace(f, e);
        }return c;
      }, getDataFragment: function getDataFragment(a) {
        var b = k.pageSize,
            c = k.dataSource,
            d = this.getTotalNumber(),
            e = b * (a - 1) + 1,
            f = Math.min(a * b, d);return c.slice(e - 1, f);
      }, getTotalNumber: function getTotalNumber() {
        return this.model.totalNumber || k.totalNumber || 0;
      }, getTotalPage: function getTotalPage() {
        return Math.ceil(this.getTotalNumber() / k.pageSize);
      }, getLocator: function getLocator(a) {
        var d;return "string" == typeof a ? d = a : b.isFunction(a) ? d = a() : c('"locator" is incorrect. (String | Function)'), d;
      }, filterDataByLocator: function filterDataByLocator(a) {
        var d,
            e = this.getLocator(k.locator);if (i.isObject(a)) {
          try {
            b.each(e.split("."), function (b, c) {
              d = (d || a)[c];
            });
          } catch (a) {}d ? i.isArray(d) || c("dataSource." + e + " must be an Array.") : c("dataSource." + e + " is undefined.");
        }return d || a;
      }, parseDataSource: function parseDataSource(a, d) {
        var e = this;i.isObject(a) ? d(k.dataSource = e.filterDataByLocator(a)) : i.isArray(a) ? d(k.dataSource = a) : b.isFunction(a) ? k.dataSource(function (a) {
          i.isArray(a) || c('The parameter of "done" Function should be an Array.'), e.parseDataSource.call(e, a, d);
        }) : "string" == typeof a ? (/^https?|file:/.test(a) && (k.ajaxDataType = "jsonp"), d(a)) : c('Unexpected type of "dataSource".');
      }, callHook: function callHook(c) {
        var d,
            e = j.data("pagination"),
            f = Array.prototype.slice.apply(arguments);return f.shift(), k[c] && b.isFunction(k[c]) && !1 === k[c].apply(a, f) && (d = !1), e.hooks && e.hooks[c] && b.each(e.hooks[c], function (b, c) {
          !1 === c.apply(a, f) && (d = !1);
        }), !1 !== d;
      }, observer: function observer() {
        var a = this,
            d = a.model.el;j.on(h + "go", function (d, e, f) {
          (e = parseInt(b.trim(e))) && (b.isNumeric(e) || c('"pageNumber" is incorrect. (Number)'), a.go(e, f));
        }), d.delegate(".J-paginationjs-page", "click", function (c) {
          var d = b(c.currentTarget),
              e = b.trim(d.attr("data-num"));if (e && !d.hasClass(k.disableClassName) && !d.hasClass(k.activeClassName)) return !1 !== a.callHook("beforePageOnClick", c, e) && (a.go(e), a.callHook("afterPageOnClick", c, e), !!k.pageLink && void 0);
        }), d.delegate(".J-paginationjs-previous", "click", function (c) {
          var d = b(c.currentTarget),
              e = b.trim(d.attr("data-num"));if (e && !d.hasClass(k.disableClassName)) return !1 !== a.callHook("beforePreviousOnClick", c, e) && (a.go(e), a.callHook("afterPreviousOnClick", c, e), !!k.pageLink && void 0);
        }), d.delegate(".J-paginationjs-next", "click", function (c) {
          var d = b(c.currentTarget),
              e = b.trim(d.attr("data-num"));if (e && !d.hasClass(k.disableClassName)) return !1 !== a.callHook("beforeNextOnClick", c, e) && (a.go(e), a.callHook("afterNextOnClick", c, e), !!k.pageLink && void 0);
        }), d.delegate(".J-paginationjs-go-button", "click", function (c) {
          var e = b(".J-paginationjs-go-pagenumber", d).val();if (!1 === a.callHook("beforeGoButtonOnClick", c, e)) return !1;j.trigger(h + "go", e), a.callHook("afterGoButtonOnClick", c, e);
        }), d.delegate(".J-paginationjs-go-pagenumber", "keyup", function (c) {
          if (13 === c.which) {
            var e = b(c.currentTarget).val();if (!1 === a.callHook("beforeGoInputOnEnter", c, e)) return !1;j.trigger(h + "go", e), b(".J-paginationjs-go-pagenumber", d).focus(), a.callHook("afterGoInputOnEnter", c, e);
          }
        }), j.on(h + "previous", function (b, c) {
          a.previous(c);
        }), j.on(h + "next", function (b, c) {
          a.next(c);
        }), j.on(h + "disable", function () {
          a.disable();
        }), j.on(h + "enable", function () {
          a.enable();
        }), j.on(h + "refresh", function (b, c) {
          a.refresh(c);
        }), j.on(h + "show", function () {
          a.show();
        }), j.on(h + "hide", function () {
          a.hide();
        }), j.on(h + "destroy", function () {
          a.destroy();
        });var e = Math.max(a.getTotalPage(), 1),
            f = k.pageNumber;a.isDynamicTotalNumber && (f = 1), k.triggerPagingOnInit && j.trigger(h + "go", Math.min(f, e));
      } };if (j.data("pagination") && !0 === j.data("pagination").initialized) {
      if (b.isNumeric(f)) return j.trigger.call(this, h + "go", f, arguments[1]), this;if ("string" == typeof f) {
        var m = Array.prototype.slice.apply(arguments);switch (m[0] = h + m[0], f) {case "previous":case "next":case "go":case "disable":case "enable":case "refresh":case "show":case "hide":case "destroy":
            j.trigger.apply(this, m);break;case "getSelectedPageNum":
            return j.data("pagination").model ? j.data("pagination").model.pageNumber : j.data("pagination").attributes.pageNumber;case "getTotalPage":
            return Math.ceil(j.data("pagination").model.totalNumber / j.data("pagination").model.pageSize);case "getSelectedPageData":
            return j.data("pagination").currentPageData;case "isDisabled":
            return !0 === j.data("pagination").model.disabled;default:
            c("Unknown action: " + f);}return this;
      }e(j);
    } else i.isObject(f) || c("Illegal options");return d(k), l.initialize(), this;
  }, b.fn[g].defaults = { totalNumber: 0, pageNumber: 1, pageSize: 10, pageRange: 2, showPrevious: !0, showNext: !0, showPageNumbers: !0, showNavigator: !1, showGoInput: !1, showGoButton: !1, pageLink: "", prevText: "", nextText: "", ellipsisText: "...", goButtonText: "Go", classPrefix: "paginationjs", activeClassName: "active", disableClassName: "disabled", inlineStyle: !0, formatNavigator: "<%= currentPage %> / <%= totalPage %>", formatGoInput: "<%= input %>", formatGoButton: "<%= button %>", position: "bottom", autoHidePrevious: !1, autoHideNext: !1, triggerPagingOnInit: !0, hideWhenLessThanOnePage: !1, showFirstOnEllipsisShow: !0, showLastOnEllipsisShow: !0, callback: function callback() {} }, b.fn.addHook = function (a, d) {
    arguments.length < 2 && c("Missing argument."), b.isFunction(d) || c("callback must be a function.");var e = b(this),
        f = e.data("pagination");f || (e.data("pagination", {}), f = e.data("pagination")), !f.hooks && (f.hooks = {}), f.hooks[a] = f.hooks[a] || [], f.hooks[a].push(d);
  }, b[g] = function (a, d) {
    arguments.length < 2 && c("Requires two parameters.");var e;if (e = "string" != typeof a && a instanceof jQuery ? a : b(a), e.length) return e.pagination(d), e;
  };var i = {};b.each(["Object", "Array", "String"], function (a, b) {
    i["is" + b] = function (a) {
      return f(a) === b.toLowerCase();
    };
  }), "function" == typeof define && define.amd && define(function () {
    return b;
  });
}(undefined, window.jQuery);

},{"babel-runtime/helpers/typeof":9}]},{},[106,105,108,107,109,104,110]);
